import {
    APP_TITLE,
    LANDING_BRIEF,
    LANDING_LANGUAGE_SELECTOR,
    LANDING_COUNTRY_SELECTOR,
    LANDING_TERMS,
    LANDING_TERMS_ERROR,
    LANDING_CAPTCHA_ERROR,
    BUTTON_PREV,
    BUTTON_NEXT,
    BUTTON_SUBMIT,
    MENU_FEEDBACK_FORM,
    MENU_FEEDBACK_STATUS,
    MENU_FORM_INTAKE,
    MENU_FORM_EVENT_DETAILS,
    MENU_FORM_PRODUCT_INFO,
    SYSTEM_FEEDBACK_FORM,
    SYSTEM_FEEDBACK_STATUS,
    FORM_TITLE,
    FORM_MANDATORY_FIELDS,
    APP_DESCRIPTION,
    SUBMIT_FEEDBACK,
    CHECK_SUBMITTED_FEEDBACK,
    BTN_LAUNCH_FORM,
    BTN_CHECK_STATUS,
    SELECT_RESPONSE,
    FUNCTION_ROLE,
    CUSTOMER_ACCOUNT_NUMBER,
    ENTER_CUSTOMER_ACCOUNT,
    HELP_CUSTOMER_ACCOUNT_NUMBER,
    EVENT_REPORTED,
    REFERENCE_NUMBER,
    ENTER_REFERENCE,
    WHO_REPORTED_TO,
    WHO_WAS_NOTIFIED,
    ENTER_NAME,
    YOUR_NAME,
    OCCUPATION,
    PHONE_NUMBER,
    ENTER_PHONE_NUMBER,
    ENTER_EMAIL,
    EMAIL_ADDRESS,
    ENTER_ADDRESS,
    ENTER_NA_IF_UNKNOWN,
    FACILITY_HOSPITAL,
    ENTER_FACILITY,
    ADDRESS_1,
    ADDRESS_2,
    CITY,
    STATE,
    POSTAL_CODE,
    COUNTRY,
    END_USER_CUSTOMER,
    ADDITIONAL_CONTACT_PERSON,
    ADDITIONAL_PHONE,
    ADDITIONAL_EMAIL,
    ANOTHER_FACILITY_ADDRESS,
    ANOTHER_FACILITY_HOSPITAL,
    ANOTHER_ENTER_FACILITY,
    ANOTHER_ADDRESS_1,
    ANOTHER_ADDRESS_2,
    ANOTHER_CITY,
    ANOTHER_STATE,
    ANOTHER_POSTAL_CODE,
    ANOTHER_COUNTRY,
    LOT_SERIAL_NUMBER,
    ENTER_LOT_SERIAL_NUMBER,
    HELP_LOT_SERIAL_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
    PRODUCT_CODE,
    ENTER_PRODUCT_CODE,
    HELP_PRODUCT_CODE,
    NDC,
    ENTER_NDC,
    UDI,
    ENTER_UDI,
    PRODUCT_NAME,
    ENTER_PRODUCT_NAME,
    HELP_PRODUCT_NAME,
    BEST_DESCRIBES,
    QUANTITY_TO_SELECT,
    ENTER_QUANTITY,
    HELP_QUANTITY,
    UNIT,
    AVAILABLE_TO_RETURNED,
    PHOTOGRAPH_AVAILABLE,
    HELP_PHOTOGRAPH_AVAILABLE,
    UPLOAD_IMAGES,
    REPORTER_NAME,
    REPORTER_FACILITY,
    REPORTER_OCCUPATION,
    ENTER_NUMBER,
    REPORTER_PHONE_NUMBER,
    REPORTER_EMAIL_ADDRESS,
    EMPLOYEE_NAME,
    EMPLOYEE_PHONE_NUMBER,
    EMPLOYEE_EMAIL_ADDRESS,
    RETURNING_FOR_INVESTIGATION,
    HELP_RETURNING_FOR_INVESTIGATION,
    UNUSED_VANTIVE_PRODUCT,
    YOU_INDICATED_SAMPLES,
    SAMPLE_RETURN_KIT,
    A_BOX_WITH_A_PREPAID_LABEL,
    SAME_AS_MY_ADDRESS,
    OTHER_CONTACT_NAME,
    OTHER_CONTACT_OCCUPATION,
    OTHER_CONTACT_PHONE_NUMBER,
    OTHER_CONTACT_EMAIL_ADDRESS,
    MANUFACTURED_BY_ANOTHER_COMPANY,
    CUSTOMER_EXPLICITLY_REQUEST,
    EXPLICITLY_REQUEST_CREDIT,
    PRODUCT_FROM_VANTIVE,
    QUANTITY_REQUESTED_CREDIT,
    ENTER_OCCUPATION,
    LOT_QUANTITY_NUMBER,
    WHOLESALERS_NAME,
    PLACE_WHOLESALERS_NAME,
    DATE_OF_EVENT,
    DATE_OF_EVENT_MSG,
    HELP_DATE_OF_EVENT,
    DATE_VANTIVE_EMPLOYEE,
    DURING_WHAT_PROCESS,
    WAS_THE_PATIENT,
    WERE_YOU_CONNECTED,
    PROVIDE_ANY_ADDITIONAL,
    HELP_YOU_IDENTIFIED_MORE,
    ENTER_DETAILS,
    PROVIDE_ANY_ATTACHMENT,
    WAS_NEGATIVE_MEDICAL,
    WAS_MEDICAL_INTERVENTION,
    PROVIDE_DETAILS,
    REQUIRED_TREATMENT,
    ENTER_TREATMENT,
    RELEVANT_TESTS,
    HELP_RELEVANT_TESTS,
    RELEVANT_MEDICAL_HISTORY,
    ENTER_HISTORY,
    PATIENT_NAME,
    PATIENT_INITIALS,
    PATIENT_PHONE_NUMBER,
    PATIENT_EMAIL_ADDRESS,
    I_DO_NOT_WISH_TO_PROVIDE,
    PATIENT_ADDRESS,
    SAME_ADDRESS,
    DRUG_BEING_USED,
    PATIENT_IDENTIFIER,
    PATIENT_AGE_OR_DOB,
    ENTER_PATIENT_AGE,
    PATIENT_GENDER,
    PATIENT_WEIGHT,
    ENTER_WEIGHT,
    PATIENT_WEIGHT_UNIT,
    MY_NAME,
    ENTER_IN_YOUR_CONTACT,
    MY_PHONE_NUMBER,
    MY_EMAIL_ADDRESS,
    MY_ADDRESS,
    NAME_OF_VANTIVE_DRUG,
    ENTER_DRUG_NAME,
    PLEASE_PROVIDE_THE_NAME,
    APPLY_TO_EACH_UNIT,
    SELECT_THE_COMPONENT,
    USE_THE_DIAGRAM,
    TYPE_OF_DAMAGE,
    PLEASE_ENTER_VALUE,
    WAS_THE_PRODUCT_KINKED,
    WERE_ANY_CLEANING,
    WHAT_WAS_THE_DISINFECTANT,
    NOTE_VANTIVE_LABELING,
    SELECT_ALL_THAT_APPLY,
    DID_FOLLOWING_OCCUR,
    SELECT_THE_LOCATION,
    WAS_THE_PRODUCT_EXPOSED,
    HOW_LONG_TRANSFER,
    WAS_THERE_DIFFICULTY,
    WAS_DEVICE_OR_TOOL,
    DESCRIBE_HOW_PRODUCT,
    DID_YOU_OBSERVE,
    WERE_DIFFICULTIES_PUTTING,
    WAS_THE_TRANSFER,
    SELECT_TYPE_OF_FLOW,
    WAS_ANYTHING_BLOCKING,
    WAS_ANY_ALARM,
    SELECT_BEST_DESCRIBE,
    WERE_THE_MINICAPS,
    WAS_THE_SPONGE_VISIBLE,
    WHERE_PARTICULATE_MATTERFOREIGN,
    DESCRIBE_THE_EXACT_LOCATION,
    WAS_THE_PARTICULATE_MATTER,
    DOES_THE_PARTICULATE_MATER,
    WHAT_COMPONENT_DOES,
    SELECT_CONNECTION_ISSUE,
    WERE_ASSIST_DEVICES,
    WERE_ANY_DIFFICULTIES,
    PROVIDE_PRODUCT_INFORMATION,
    WERE_THE_SPIKE_LUER,
    VANTIVE_LABELING_STATES,
    WERE_PETS_OR_ANIMALS,
    VANTIVE_LABELING_CONTAMINATION,
    WERE_OTHER_ISSUES,
    WAS_MINICAP_TWISTED,
    WERE_DIFFICULTIES_TRANSFER_SET,
    DID_TRANSFER_SET_CONNECTORS,
    WHAT_WAS_THE_ALARM,
    WHERE_OBSERVED_DAMAGE,
    SELECT_THE_TYPE_OBSERVED,
    DID_DAMAGE_CAUSE_LEAK,
    WAS_THE_SHIPPING_CARTON,
    SELECT_FLOW_ISSUE_OBSERVED,
    HOW_LONG_WAS_STORAGE,
    WAS_THERE_AN_ADAPTER,
    NAME_AND_MODEL,
    NAME_VAPORIZER,
    WAS_VIAL_INVERTED,
    WHAT_VIAL_USED,
    DRUG_NAME_MANUFACTURER,
    WERE_BREAK_FRANGIBLE,
    WAS_ALARM_ASSOCIATED,
    WHAT_PART_DISCOLORED,
    DESCRIBE_DISCOLORATION,
    HOW_PRODUCT_STORED,
    DOES_DISCOLORATION_APPEAR,
    WHICH_CHAMBER_DISCOLORED,
    WAS_PEEL_SEAL_INTERCHAMBER,
    WAS_DISCOLORATION_NOTICED,
    SELECT_SPECIFICALLY_DESCRIBES,
    WHAT_DEVICE_HAD_ALARM,
    WHAT_MISSING_MISASSEMBLED,
    RECONSTITUTION_ISSUE,
    WHAT_MEDICATION_SOLUTION,
    WHAT_VOLUME_MEDICATION,
    WHAT_DEVICES_RECONSTITUTION,
    WAS_PRODUCT_EXPOSED_HEAT,
    DESCRIBE_EXPOSURE,
    WHAT_USED_ACTIVATE_SOLUTION,
    WAS_DAMAGE_OBSERVED,
    DESCRIBE_THE_DAMAGE,
    APPROXIMATELY_SOLUTION_POWDER,
    WAS_LEAK_OBSERVED,
    WHAT_FEATUR_DIFFICULT_USE,
    HOW_WAS_DIFFICULT_USE,
    WHERE_MATTER_FOREIGN,
    DOES_PARTICULATE_MATTER,
    DESCRIBE_EXACT_LOCATION,
    WAS_MATTER_FOREIGN,
    WHEN_MATTER_FOREIGN,
    PROVIDE_INFORMATION_MEDICATION,
    PRODUCT_NAME_CODE_NUMBER,
    DESCRIBE_SPIKING,
    INCLUDE_NEEDLE,
    WHAT_ADMINISTRATION_RECONSTITUTION,
    INCLUDE_MANUFACTURER,
    WAS_MEDICATION_ADDITIVE,
    WHAT_MEDICATION_ADDITIVE,
    WHAT_STATE_OF_PRODUCT,
    AFTER_UNITS_SAT,
    DID_ATTEMPT_AGITATE,
    DID_PRECIPITATE_DISSOLVE,
    WHAT_STORAGE_TEMPERATURE,
    PROVIDE_TEMPERATURE_LOCATION,
    ARE_TEMPERATURE_LOGS,
    LOGS_CAN_BE_ATTACHED,
    IS_THE_STORAGE_UNIT,
    HOW_PRODUCT_THAWED,
    WHAT_STORAGE_CONDITIONS,
    WAS_ANY_DAMAGE,
    MORE_SPECIFIC_INFORMATION,
    WHAT_PURPOSE_INDICATION,
    WHAT_ROUTE_ADMINISTRATION,
    WHAT_DATE_ADMINISTRATION,
    WHAT_DOSAGE_STRENGTH,
    WAS_RECENT_PRESCRIPTION,
    WHAT_WAS_STORAGE_TEMPERATURE,
    WERE_ANY_ADJUSTMENTS,
    SELECT_APPROPRIATE_DESCRIPTION,
    SELECT_LABELING_ISSUE,
    WAS_CONNECTION_SECURE,
    WAS_EXPIRED_PRODUCT,
    WAS_COMPONENT_DAMAGED,
    WERE_ABNORMALITIES_DAMAGE,
    WHAT_PURCHASE_ORDER_NUMBER,
    WHAT_DATE_OF_ADMINISTRATION,
    WHAT_WAS_EXPIRATION_DATE,
    DESCRIBE_WAS_INCORRECT,
    WHAT_SCANNER_USED,
    WAS_OVERPOUCH_POUCH,
    WHAT_BACKGROUND_COLOR,
    DO_ALL_OF_THE_LABELS,
    PRODUCT_INFORMATION,
    IS_A_BARCODE_SCANNER,
    HOW_ARE_THESE_PRODUCTS,
    WHAT_INFORMATION_INCORRECTLY,
    WAS_THERE_LEAK,
    WHERE_LEAK_OBSERVED,
    WAS_FRANGIBLE_OBSERVED,
    IS_MOISTURE_CLEAR,
    WHO_IS_YOUR_DISTRIBUTOR,
    WHAT_MANUFACTURER_MEDICATION,
    WHAT_GAUGE_NEEDLE,
    WHAT_ADMINISTRATION_SET,
    WAS_DIFFICULTY_SPIKING,
    WERE_FOLLOWING_SCENARIOS,
    WAS_FRANGIBLE_OBSERVED_DEFECT,
    WHAT_AMOUNT_PRESSURE,
    WAS_BAG_COMPLETELY,
    WHAT_MANUFACTURER_MODEL,
    WHAT_PRESSURE_PRIOR,
    LIST_THE_VAPORIZER,
    APPROXIMATELY_HOW_MUCH,
    WAS_THE_BOTTLE_DIFFICULT,
    WERE_VISIBLE_DEFECTS,
    SELECT_THE_OPTION,
    PROVIDE_INVOLVED_CONNECTION_ISSUE,
    WHICH_PART_SEPARATED,
    WHAT_COMPONENT_DISCOLORED,
    SELECT_DESCRIBES_DISCOLORATION,
    WAS_THE_SET_DISCOLORED,
    DID_SET_CHANGE_COLOR,
    WHAT_MEDICATION_ADDED,
    WHERE_MATERIAL_LOCATED,
    DESCRIBE_APPEARANCE_COLOR_SIZE,
    WAS_EMBEDDED_PLASTIC,
    WAS_THERE_A_PRECIPITATE,
    WHAT_MEDICATIONS_SOLUTIONS,
    WHERE_DAMAGE_COMPONENT_AFFECTED,
    WHAT_DAMAGE_ISSUE,
    DID_ISSUE_RESULT,
    WAS_PATIENT_CONNECTED,
    WAS_PRODUCT_REPLACED,
    WHICH_SITUATION_BEST,
    SELECT_MOST_LABELING_ISSUE,
    WHAT_INFORMATION_DISPLAYED,
    WHAT_SCANNER_WAS_USED,
    INCLUDE_THE_MODEL_NAME,
    WAS_PRODUCT_ORDERED,
    WHERE_LEAK_COMING,
    DID_SCENARIOS_OCCURRED_LEAK,
    WAS_POWER_INJECTOR,
    WHAT_INJECTOR_USED,
    MANUFACTURER_NAME_CODE_LOT,
    DESCRIBE_INCORRECT_INCOMPLETE,
    PROVIDE_INFORMATION_SECOND_PRODUCT,
    WHICH_COMPONENTS_WERE_FOUND,
    DESCRIBE_CUT_HOLE_SLICE,
    WAS_LEAK_ORIGINATING,
    PROVIDE_DISCONNECTION_CONNECTION,
    WHICH_SPECIFIC_BONDED,
    WERE_VISIBLE_IRREGULARITIES,
    WAS_SUCCESSFUL_CONNECTION,
    WAS_TOOL_USED_ASSIST,
    WERE_LUER_CONNECTIONS,
    WAS_PRODUCT_SECURELY,
    WHICH_DESCRIBES_FLOW_ISSUE,
    WHAT_FLOWING_BACKWARDS,
    DESCRIBE_COMPONENTS_BACKFLOW,
    DO_SITUATIONS_APPLY,
    WHICH_SPECIFIC_AREA,
    WAS_FLOW_PREVIOUSLY_SEEN,
    WAS_ANY_FOLLOWING_OBSERVED,
    WHERE_SIMULTANEOUS_FLOW,
    WHAT_TYPE_HANGER,
    WHAT_WAS_HANGER_LENGTH,
    WHICH_BAG_LOWER,
    WHAT_Y_SITE_WAS,
    WHAT_COMPONENT_WITHIN,
    WAS_COMPONENT_SET_REPLACED,
    WHAT_VOLUME_FLUID_PERIOD_TIME,
    WHAT_VOLUME_FLUID_OVER_TIME,
    WAS_USED_WITH_PUMP,
    DID_CLAMP_FAIL,
    WHAT_CLAMP_FAILED,
    WAS_ISSUES_OBSERVED_CLAMP,
    DO_OTHER_SITUATIONS_DESCRIBE,
    DESCRIBE_ALARM_OBSERVED,
    INCLUDE_ANY_MESSAGES,
    WHICH_CLAMP_HAD_ISSUE,
    WHICH_TYPE_CLAMP_ISSUE,
    SELECT_BEST_DESCRIBES_ISSUE,
    PROVIDE_MORE_DETAILS,
    PROVIDE_MORE_DETAILS_INSTRUCTIONS,
    DESCRIBE_THE_SMELL,
    WAS_ISSUES_WITH_SET,
    WHERE_LEAK_LOCATED,
    DID_OCCUR_WITH_LEAK,
    PROVIDE_INVOLVED_DISCONNECTION,
    DID_OCCURRED_WITH_THE_LEAK,
    WHERE_WAS_PRODUCT_DAMAGED,
    SELECT_ALL_APPLY,
    DESCRIBE_OBSERVED_DAMAGE,
    WHAT_COMPONENT_IS_DISCOLORED,
    DESCRIBE_HUE_TINT_SHADE,
    INSIDE_OUTSIDE_OVERPOUCH,
    DESCRIBE_EXACT_LOCATION_SIZE,
    DOES_THE_PARTICULATE_MATTER,
    WAS_PARTICULATE_MATERIAL_EMBEDDED,
    DOES_APPEAR_PRODUCT_MATERIAL,
    WHERE_DID_THE_ISSUE_OCCUR,
    LIST_COMPONENTS_IF,
    WERE_THERE_VISIBLE_IRREGULARITIES,
    SELECT_OPTION_FLOW_ISSUE,
    DESCRIBE_IRREGULARITIES,

    HOW_PRODUCT_SETUP,
    SELECT_MOST_APPROPRIATE_DESCRIPTION,
    DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
    WAS_SHIPPING_CARTON_DAMAGED,
    WHAT_PRODUCT_WAS_SUPPOSED,
    IF_PRODUCT_CODE_NOT,
    WAS_THE_CASE_MISSING,
    WHAT_CARRIER_DELIVERED,
    WHAT_IS_PURCHASE_ORDER_NUMBER,
    WHAT_QUANTITY_MISSING_UNITS,
    WAS_EXPIRED_PRODUCT_USE,
    ADD_PRODUCT_TO_THE_GRID,
    SAVE,
    CANCEL,
    ADD_MORE_PRODUCTS,
    REPORTER_ADDRESS,
    ATTACHMENTS,
    COPYRIGHT,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    COOKIE_POLICY,
    FORM_SUB_TITLE,
    OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
    OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
    OPTION_FUNCTIONOPTIONS_CAREGIVER,
    OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
    OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
    OPTION_FUNCTIONOPTIONS_PATIENT,
    OPTION_FUNCTIONOPTIONS_OTHER,
    OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
    OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
    OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
    OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
    OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
    OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
    OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_OCCUPATIONOPTIONS_NURSE,
    OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_UNITOPTIONS_BOXES,
    OPTION_UNITOPTIONS_PALLETS,
    OPTION_UNITOPTIONS_UNITS,
    OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
    OPTION_PROBLEMOPTIONS_DAMAGE,
    OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
    OPTION_PROBLEMOPTIONS_DISCOLORED,
    OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
    OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
    OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
    OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
    OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
    OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
    OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
    OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
    OPTION_PATIENTSEXOPTIONS_FEMALE,
    OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
    OPTION_PATIENTSEXOPTIONS_MALE,
    OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
    OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
    OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
    OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
    OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
    OPTION_REPORTEDTOOPTIONS_VANTIVE,
    OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
    OPTION_REPORTEDTOOPTIONS_EMA,
    OPTION_REPORTEDTOOPTIONS_FDA,
    OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
    OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
    OPTION_REPORTEDTOOPTIONS_TUV,
    OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
    OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
    OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
    OPTION_DAMAGEMINICAPOPTIONS_CARTON,
    OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
    OPTION_DAMAGEMINICAPOPTIONS_POUCH,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
    OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
    OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
    OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
    OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
    OPTION_BLOCKINGFLOWOPTIONS_KINK,
    OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
    OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
    OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
    OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
    OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
    OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
    OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
    OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
    OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
    OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
    OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
    OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
    OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
    OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
    OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
    OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
    OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
    OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
    OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
    OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
    OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
    OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_DESCOFISSUEOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
    OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
    OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
    OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
    OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
    OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
    OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
    OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
    OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
    OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
    OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
    NO_DESCRIBE_THE_COLOR,
    OPTION_LIQUIDSPILLEDOPTIONS_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
    OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
    OPTION_VISIBLEDEFECTSOPTIONS_CAP,
    OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
    OPTION_VISIBLEDEFECTSOPTIONS_NONE,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
    OTHER_PLEASE_SPECIFY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
    OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
    OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
    OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
    OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
    OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
    DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
    DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
    OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
    OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
    OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
    OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
    OPTION_LEAKCOMINGFROMOPTIONS_CAP,
    OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
    OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
    OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
    OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
    OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
    OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
    OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
    OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
    OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
    OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
    DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
    YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
    OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
    OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
    OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
    OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
    OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
    OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
    OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
    OPTION_BAGLOWEROPTIONS_PRIMARY,
    OPTION_BAGLOWEROPTIONS_SECONDARY,
    OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
    OPTION_YSITECONNECTEDOPTIONS_LOWER,
    OPTION_YSITECONNECTEDOPTIONS_UPPER,
    OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
    OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
    OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
    OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
    OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
    OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
    OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
    OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
    OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
    OPTION_LEAKOCCUROPTIONS_OTHER,
    OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
    OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
    OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
    OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
    OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
    OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
    OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
    OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
    OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
    OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
    OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
    OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
    OPTION_ALARMOPTIONS_YES_SPECIFY,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
    OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
    OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
    OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
    OPTION_COMPONENTHADISSUEOPTIONS_LINES,
    OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
    OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
    OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
    OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
    OPTION_MONTHOPTIONS_JAN,
    OPTION_MONTHOPTIONS_FEB,
    OPTION_MONTHOPTIONS_MAR,
    OPTION_MONTHOPTIONS_APR,
    OPTION_MONTHOPTIONS_MAY,
    OPTION_MONTHOPTIONS_JUN,
    OPTION_MONTHOPTIONS_JUL,
    OPTION_MONTHOPTIONS_AUG,
    OPTION_MONTHOPTIONS_SEP,
    OPTION_MONTHOPTIONS_OCT,
    OPTION_MONTHOPTIONS_NOV,
    OPTION_MONTHOPTIONS_DEC,
    OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
    OPTION_PROBLEMOPTIONS_OTHER,
    OPTION_REPORTEDTOOPTIONS_OTHER,
    OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
    OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
    OPTION_BLOCKINGFLOWOPTIONS_OTHER,
    OPTION_DESCRIBEISSUEOPTIONS_OTHER,
    OPTION_MATERIALLOCATEDOPTIONS_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
    OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
    OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_OTHER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
    OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
    OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
    OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
    OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
    OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
    OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
    OPTION_ADDANOTHERFACILITYOPTIONS_NO,
    OPTION_ADDANOTHERFACILITYOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_NO,
    OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
    OPTION_PATIENINVOLVEMENTOPTIONS_YES,
    OPTION_OTHERFACILITYREPORTOPTIONS_NO,
    OPTION_OTHERFACILITYREPORTOPTIONS_YES,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
    OPTION_AVAILABILITYOPTIONS_NO,
    OPTION_AVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYOPTIONS_NO,
    OPTION_MEDIAAVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
    OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
    OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
    OPTION_COUNTERACTIONOPTIONS_NO,
    OPTION_COUNTERACTIONOPTIONS_YES,
    OPTION_DRUGUSEDOPTIONS_NO,
    OPTION_DRUGUSEDOPTIONS_YES,
    OPTION_SHARECONTACTOPTIONS_NO,
    OPTION_SHARECONTACTOPTIONS_YES,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
    OPTION_DIRECTORDEROPTIONS_NO,
    OPTION_DIRECTORDEROPTIONS_YES,
    OPTION_EXCESSIVEFORCEOPTIONS_NO,
    OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
    OPTION_EXCESSIVEFORCEOPTIONS_YES,
    OPTION_TWISTCLAMPOPTIONS_NO,
    OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TWISTCLAMPOPTIONS_YES,
    OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
    OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_NO,
    OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_YES,
    OPTION_SPONGEVISIBLEOPTIONS_NO,
    OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
    OPTION_SPONGEVISIBLEOPTIONS_YES,
    OPTION_MATERIALEMBEDDEDOPTIONS_NO,
    OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_MATERIALEMBEDDEDOPTIONS_YES,
    OPTION_PIECESMATERIALOPTIONS_NO,
    OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
    OPTION_PIECESMATERIALOPTIONS_YES,
    OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
    OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
    OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
    OPTION_INITIALCONNECTIONOPTIONS_NO,
    OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
    OPTION_INITIALCONNECTIONOPTIONS_YES,
    OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
    OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
    OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
    OPTION_PETSORANIMALSOPTIONS_NO,
    OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
    OPTION_PETSORANIMALSOPTIONS_YES,
    OPTION_MINICAPTWISTEDOPTIONS_NO,
    OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
    OPTION_MINICAPTWISTEDOPTIONS_YES,
    OPTION_TRANSFERSETOPTIONS_NO,
    OPTION_TRANSFERSETOPTIONS_UNKNOWN,
    OPTION_TRANSFERSETOPTIONS_YES,
    OPTION_RESIDUETHREADSOPTIONS_NO,
    OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_NO,
    OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_YES,
    OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
    OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
    OPTION_ADAPTERDEVICEOPTIONS_NO,
    OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
    OPTION_ADAPTERDEVICEOPTIONS_YES,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
    OPTION_FORTHMOTIONOPTIONS_NO,
    OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
    OPTION_FORTHMOTIONOPTIONS_YES,
    OPTION_ALARMNOFLOWOPTIONS_NO,
    OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
    OPTION_ALARMNOFLOWOPTIONS_YES,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
    OPTION_BROKENACTIVATEDOPTIONS_NO,
    OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
    OPTION_BROKENACTIVATEDOPTIONS_YES,
    OPTION_vaporizerSightGlassOptions_NO,
    OPTION_vaporizerSightGlassOptions_UNKNOWN,
    OPTION_vaporizerSightGlassOptions_YES,
    OPTION_PRODUCTHEATOPTIONS_NO,
    OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
    OPTION_PRODUCTHEATOPTIONS_YES,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
    OPTION_LEAKOBSERVEDOPTIONS_NO,
    OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
    OPTION_LEAKOBSERVEDOPTIONS_YES,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
    OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
    OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
    OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
    OPTION_AGITATEUNITOPTIONS_NO,
    OPTION_AGITATEUNITOPTIONS_UNKNOWN,
    OPTION_AGITATEUNITOPTIONS_YES,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
    OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
    OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
    OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
    OPTION_EXPIREDPRODUCTOPTIONS_NO,
    OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTOPTIONS_YES,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
    OPTION_BARCODESCANNEROPTIONS_NO,
    OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
    OPTION_BARCODESCANNEROPTIONS_YES,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
    OPTION_FRANGIBLEBROKENOPTIONS_NO,
    OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEBROKENOPTIONS_YES,
    OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
    OPTION_MOISTURECLEAROPTIONS_YES,
    OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
    OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
    OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
    OPTION_PRESSURECUFFOPTIONS_NO,
    OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
    OPTION_PRESSURECUFFOPTIONS_YES,
    OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
    OPTION_ADDINGMEDICATIONOPTIONS_NO,
    OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
    OPTION_ADDINGMEDICATIONOPTIONS_YES,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
    OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
    OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
    OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
    OPTION_WASPOWERINJECTOROPTIONS_NO,
    OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
    OPTION_WASPOWERINJECTOROPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
    OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
    OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
    OPTION_TOOLUSEDASSISTOPTIONS_NO,
    OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_NO,
    OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_YES,
    OPTION_PRIORDISCONNECTINGOPTIONS_NO,
    OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
    OPTION_PRIORDISCONNECTINGOPTIONS_YES,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
    OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
    OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
    OPTION_WITHPUMPOPTIONS_NO,
    OPTION_WITHPUMPOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_NO,
    OPTION_CLAMPFAILOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_YES,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
    OPTION_GELPACKSOPTIONS_NO,
    OPTION_GELPACKSOPTIONS_YES,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
    OPTION_ALARMOPTIONS_NO,
    OPTION_ALARMOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
    OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_NO,
    OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_YES,
    OPTION_FULLYTIGHTENEDOPTIONS_NO,
    OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
    OPTION_FULLYTIGHTENEDOPTIONS_YES,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_NO,
    OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_YES,
    OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
    OPTION_EXPLICITLYREQUESTOPTIONS_NO,
    OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
    OPTION_EXPLICITLYREQUESTOPTIONS_YES,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
    OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
    OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
    OPTION_HANGERUSEDOPTIONS_UNKNOWN,
    OPTION_HANGERUSEDOPTIONS_NONE,
    OPTION_BAGLOWEROPTIONS_UNKNOWN,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
    OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
    OPTION_WEIGHTUNITOPTIONS_POUND,
    OPTION_INFUSATESOLUTIONOPTIONS_NO,
    OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
    PLEASE_ENTER_THE_VALUE,
    PLEASE_SELECT_THE_VALUE,
    PLEASE_SELECT_THE_DATE,
    PLEASE_CHOOSE_THE_VALUE,
    OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
    OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
    OPTION_COUNTRYOPTIONS_KOSOVO,
    OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
    OPTION_COUNTRYOPTIONS_AFGHANISTAN,
    OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
    OPTION_COUNTRYOPTIONS_ALBANIA,
    OPTION_COUNTRYOPTIONS_ALGERIA,
    OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
    OPTION_COUNTRYOPTIONS_ANDORRA,
    OPTION_COUNTRYOPTIONS_ANGOLA,
    OPTION_COUNTRYOPTIONS_ANGUILLA,
    OPTION_COUNTRYOPTIONS_ANTARCTICA,
    OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
    OPTION_COUNTRYOPTIONS_ARGENTINA,
    OPTION_COUNTRYOPTIONS_ARMENIA,
    OPTION_COUNTRYOPTIONS_ARUBA,
    OPTION_COUNTRYOPTIONS_AUSTRALIA,
    OPTION_COUNTRYOPTIONS_AUSTRIA,
    OPTION_COUNTRYOPTIONS_AZERBAIJAN,
    OPTION_COUNTRYOPTIONS_BAHAMAS,
    OPTION_COUNTRYOPTIONS_BAHRAIN,
    OPTION_COUNTRYOPTIONS_BANGLADESH,
    OPTION_COUNTRYOPTIONS_BARBADOS,
    OPTION_COUNTRYOPTIONS_BELARUS,
    OPTION_COUNTRYOPTIONS_BELGIUM,
    OPTION_COUNTRYOPTIONS_BELIZE,
    OPTION_COUNTRYOPTIONS_BENIN,
    OPTION_COUNTRYOPTIONS_BERMUDA,
    OPTION_COUNTRYOPTIONS_BHUTAN,
    OPTION_COUNTRYOPTIONS_BOLIVIA,
    OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
    OPTION_COUNTRYOPTIONS_BOTSWANA,
    OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
    OPTION_COUNTRYOPTIONS_BRAZIL,
    OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
    OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
    OPTION_COUNTRYOPTIONS_BULGARIA,
    OPTION_COUNTRYOPTIONS_BURKINA_FASO,
    OPTION_COUNTRYOPTIONS_BURUNDI,
    OPTION_COUNTRYOPTIONS_CAMBODIA,
    OPTION_COUNTRYOPTIONS_CAMEROON,
    OPTION_COUNTRYOPTIONS_CANADA,
    OPTION_COUNTRYOPTIONS_CAPE_VERDE,
    OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
    OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_CHAD,
    OPTION_COUNTRYOPTIONS_CHILE,
    OPTION_COUNTRYOPTIONS_CHINA,
    OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
    OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
    OPTION_COUNTRYOPTIONS_COLOMBIA,
    OPTION_COUNTRYOPTIONS_COMOROS,
    OPTION_COUNTRYOPTIONS_CONGO,
    OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
    OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
    OPTION_COUNTRYOPTIONS_COSTA_RICA,
    OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
    OPTION_COUNTRYOPTIONS_CROATIA,
    OPTION_COUNTRYOPTIONS_CUBA,
    OPTION_COUNTRYOPTIONS_CYPRUS,
    OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
    OPTION_COUNTRYOPTIONS_DENMARK,
    OPTION_COUNTRYOPTIONS_DJIBOUTI,
    OPTION_COUNTRYOPTIONS_DOMINICA,
    OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_ECUADOR,
    OPTION_COUNTRYOPTIONS_EGYPT,
    OPTION_COUNTRYOPTIONS_EL_SALVADOR,
    OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
    OPTION_COUNTRYOPTIONS_ERITREA,
    OPTION_COUNTRYOPTIONS_ESTONIA,
    OPTION_COUNTRYOPTIONS_ETHIOPIA,
    OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
    OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
    OPTION_COUNTRYOPTIONS_FIJI,
    OPTION_COUNTRYOPTIONS_FINLAND,
    OPTION_COUNTRYOPTIONS_FRANCE,
    OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
    OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
    OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
    OPTION_COUNTRYOPTIONS_GABON,
    OPTION_COUNTRYOPTIONS_GAMBIA,
    OPTION_COUNTRYOPTIONS_GEORGIA,
    OPTION_COUNTRYOPTIONS_GERMANY,
    OPTION_COUNTRYOPTIONS_GHANA,
    OPTION_COUNTRYOPTIONS_GIBRALTAR,
    OPTION_COUNTRYOPTIONS_GREECE,
    OPTION_COUNTRYOPTIONS_GREENLAND,
    OPTION_COUNTRYOPTIONS_GRENADA,
    OPTION_COUNTRYOPTIONS_GUADELOUPE,
    OPTION_COUNTRYOPTIONS_GUAM,
    OPTION_COUNTRYOPTIONS_GUATEMALA,
    OPTION_COUNTRYOPTIONS_GUERNSEY,
    OPTION_COUNTRYOPTIONS_GUINEA,
    OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
    OPTION_COUNTRYOPTIONS_GUYANA,
    OPTION_COUNTRYOPTIONS_HAITI,
    OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
    OPTION_COUNTRYOPTIONS_HONDURAS,
    OPTION_COUNTRYOPTIONS_HONG_KONG,
    OPTION_COUNTRYOPTIONS_HUNGARY,
    OPTION_COUNTRYOPTIONS_ICELAND,
    OPTION_COUNTRYOPTIONS_INDIA,
    OPTION_COUNTRYOPTIONS_INDONESIA,
    OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_IRAQ,
    OPTION_COUNTRYOPTIONS_IRELAND,
    OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
    OPTION_COUNTRYOPTIONS_ISRAEL,
    OPTION_COUNTRYOPTIONS_ITALY,
    OPTION_COUNTRYOPTIONS_JAMAICA,
    OPTION_COUNTRYOPTIONS_JAPAN,
    OPTION_COUNTRYOPTIONS_JERSEY,
    OPTION_COUNTRYOPTIONS_JORDAN,
    OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
    OPTION_COUNTRYOPTIONS_KENYA,
    OPTION_COUNTRYOPTIONS_KIRIBATI,
    OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KUWAIT,
    OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
    OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    OPTION_COUNTRYOPTIONS_LATVIA,
    OPTION_COUNTRYOPTIONS_LEBANON,
    OPTION_COUNTRYOPTIONS_LESOTHO,
    OPTION_COUNTRYOPTIONS_LIBERIA,
    OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
    OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
    OPTION_COUNTRYOPTIONS_LITHUANIA,
    OPTION_COUNTRYOPTIONS_LUXEMBOURG,
    OPTION_COUNTRYOPTIONS_MACAO,
    OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_MADAGASCAR,
    OPTION_COUNTRYOPTIONS_MALAWI,
    OPTION_COUNTRYOPTIONS_MALAYSIA,
    OPTION_COUNTRYOPTIONS_MALDIVES,
    OPTION_COUNTRYOPTIONS_MALI,
    OPTION_COUNTRYOPTIONS_MALTA,
    OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
    OPTION_COUNTRYOPTIONS_MARTINIQUE,
    OPTION_COUNTRYOPTIONS_MAURITANIA,
    OPTION_COUNTRYOPTIONS_MAURITIUS,
    OPTION_COUNTRYOPTIONS_MAYOTTE,
    OPTION_COUNTRYOPTIONS_MEXICO,
    OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
    OPTION_COUNTRYOPTIONS_MOLDOVA,
    OPTION_COUNTRYOPTIONS_MONACO,
    OPTION_COUNTRYOPTIONS_MONGOLIA,
    OPTION_COUNTRYOPTIONS_MONTENEGRO,
    OPTION_COUNTRYOPTIONS_MONTSERRAT,
    OPTION_COUNTRYOPTIONS_MOROCCO,
    OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
    OPTION_COUNTRYOPTIONS_MYANMAR,
    OPTION_COUNTRYOPTIONS_NAMIBIA,
    OPTION_COUNTRYOPTIONS_NAURU,
    OPTION_COUNTRYOPTIONS_NEPAL,
    OPTION_COUNTRYOPTIONS_NETHERLANDS,
    OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
    OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
    OPTION_COUNTRYOPTIONS_NICARAGUA,
    OPTION_COUNTRYOPTIONS_NIGER,
    OPTION_COUNTRYOPTIONS_NIGERIA,
    OPTION_COUNTRYOPTIONS_NIUE,
    OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
    OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
    OPTION_COUNTRYOPTIONS_NORWAY,
    OPTION_COUNTRYOPTIONS_OMAN,
    OPTION_COUNTRYOPTIONS_PAKISTAN,
    OPTION_COUNTRYOPTIONS_PALAU,
    OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
    OPTION_COUNTRYOPTIONS_PANAMA,
    OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
    OPTION_COUNTRYOPTIONS_PARAGUAY,
    OPTION_COUNTRYOPTIONS_PERU,
    OPTION_COUNTRYOPTIONS_PHILIPPINES,
    OPTION_COUNTRYOPTIONS_PITCAIRN,
    OPTION_COUNTRYOPTIONS_POLAND,
    OPTION_COUNTRYOPTIONS_PORTUGAL,
    OPTION_COUNTRYOPTIONS_PUERTO_RICO,
    OPTION_COUNTRYOPTIONS_QATAR,
    OPTION_COUNTRYOPTIONS_RÉUNION,
    OPTION_COUNTRYOPTIONS_ROMANIA,
    OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
    OPTION_COUNTRYOPTIONS_RWANDA,
    OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
    OPTION_COUNTRYOPTIONS_SAINT_HELENA,
    OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
    OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
    OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
    OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
    OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
    OPTION_COUNTRYOPTIONS_SAMOA,
    OPTION_COUNTRYOPTIONS_SAN_MARINO,
    OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
    OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
    OPTION_COUNTRYOPTIONS_SENEGAL,
    OPTION_COUNTRYOPTIONS_SERBIA,
    OPTION_COUNTRYOPTIONS_SEYCHELLES,
    OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
    OPTION_COUNTRYOPTIONS_SINGAPORE,
    OPTION_COUNTRYOPTIONS_SLOVAKIA,
    OPTION_COUNTRYOPTIONS_SLOVENIA,
    OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
    OPTION_COUNTRYOPTIONS_SOMALIA,
    OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
    OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    OPTION_COUNTRYOPTIONS_SPAIN,
    OPTION_COUNTRYOPTIONS_SRI_LANKA,
    OPTION_COUNTRYOPTIONS_SUDAN,
    OPTION_COUNTRYOPTIONS_SURINAME,
    OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
    OPTION_COUNTRYOPTIONS_SWAZILAND,
    OPTION_COUNTRYOPTIONS_SWEDEN,
    OPTION_COUNTRYOPTIONS_SWITZERLAND,
    OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
    OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
    OPTION_COUNTRYOPTIONS_TAJIKISTAN,
    OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_THAILAND,
    OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
    OPTION_COUNTRYOPTIONS_TOGO,
    OPTION_COUNTRYOPTIONS_TOKELAU,
    OPTION_COUNTRYOPTIONS_TONGA,
    OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
    OPTION_COUNTRYOPTIONS_TUNISIA,
    OPTION_COUNTRYOPTIONS_TURKEY,
    OPTION_COUNTRYOPTIONS_TURKMENISTAN,
    OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
    OPTION_COUNTRYOPTIONS_TUVALU,
    OPTION_COUNTRYOPTIONS_UGANDA,
    OPTION_COUNTRYOPTIONS_UKRAINE,
    OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
    OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
    OPTION_COUNTRYOPTIONS_UNITED_STATES,
    OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    OPTION_COUNTRYOPTIONS_URUGUAY,
    OPTION_COUNTRYOPTIONS_UZBEKISTAN,
    OPTION_COUNTRYOPTIONS_VANUATU,
    OPTION_COUNTRYOPTIONS_VENEZUELA,
    OPTION_COUNTRYOPTIONS_VIET_NAM,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
    OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
    OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
    OPTION_COUNTRYOPTIONS_YEMEN,
    OPTION_COUNTRYOPTIONS_ZAMBIA,
    OPTION_COUNTRYOPTIONS_ZIMBABWE,
    LANDING_TERMS_I_HAVE_READ,
    LANDING_TERMS_THE_USE_DISCLOSURE,
    LANDING_TERMS_THE_TRANSFER_OF,
    LANDING_TERMS_I_UNDERSTAND_THAT,
    OPTION_DOESTHEPARTICULATEMATTER_NO,
    OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
    OPTION_DOESTHEPARTICULATEMATTER_YES,
    I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
    PRODUCT_LOT,
    SHIPPING_DISTRIBUTION_LABEL,
    CARTON_LABEL,
    INTERNAL_PRODUCT_LABEL,
    TITLE_PD_RENAL,
    TITLE_SOLUTIONS,
    TITLE_ACCESS,
    TITLE_ALL_OTHER_PRODUCT,
    REPORTED_PROBLEM,
    LOGIN,
    SYSTEM_MENU,
    INITIATE_PRODUCT_FEEDBACK,
    FEEDBACK_STATUS,
    OKTACALLBACK,
    VALID_EMAIL,
    VALID_NUMERIC,
    PLEASE_UPLOAD_IMAGE,
    VALID_DATE,
    QUANTITY,
    EDIT,
    DELETE,
    LOT_SERIAL_NO,
    LOT_NUMBER_NOT_FOUND,
    SEARCHING_LOT_NUMBER,
    PRODUCT_CODE_NOT_FOUND,
    SEARCHING_PRODUCT_CODE,
    FILE_OF_TYPES_ARE_NOT_ALLOWED,
    THE_FILE_YOU_ARE_ATTEMPTING,
    IMAGE_ICON,
    LOGIN_TO_ACCOUNT,
    SIGN_IN_TO_YOUR_ACCOUNT,
    PASSWORD,
    SIGN_IN,
    UNKNOWN,
    ASKED_UNKNOWN,
    DD_MMM_YYYY,
    DD,
    MMM,
    YYYY,
    SELECT_COUNTRY,
    CHINESE_SIMPLIFIED_CHINESE,
    DUTCH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    MANDARIN_TRADITIONAL_CHINESE,
    POLISH,
    PORTUGUESE,
    SPANISH,
    THAI,
    TURKISH,
    VIETNAMESE,
    BROWSE,
    FEEDBACK_SUBMITTED,
    YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
    IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
    CLOSE,
    PATIENT_AGE,
    ENTER_AGE,
    PATIENT_DOB,
    RELEVANT_ATTACHMENTS,
    VANTIVE_ACCOUNT_CREDENTIALS,
    GET_PRODUCT_DETAILS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_2,
    FACILITY_ADDRESS,
    LABEL_ANOTHER_FACILITY_ADDRESS,
    CHOOSE_PRODUCT_CODE,
    PRIVACY_NOTICE,
    DECLINE,
    OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
    OPTION_COUNTRYOPTIONS_CURAÇAO,
    OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
    OPTION_COUNTRYOPTIONS_ESWATINI,
    FORM_HELP_TEXT,
    YOUR_FIRST_NAME,
    YOUR_LAST_NAME,
    MY_FIRST_NAME,
    MY_LAST_NAME,
    PATIENT_FIRST_NAME,
    PATIENT_LAST_NAME,
    REPORTER_FIRST_NAME,
    REPORTER_LAST_NAME,
    EMPLOYEE_FIRST_NAME,
    EMPLOYEE_LAST_NAME,
    END_USER_CUSTOMER_FIRST_NAME,
    END_USER_CUSTOMER_LAST_NAME,
    ADDITIONAL_CONTACT_FIRST_NAME,
    ADDITIONAL_CONTACT_LAST_NAME,
    COPYRIGHT_VANTIVE,
    COPYRIGHT_VERSION,
    ADD_ADDITIONAL_CONTACT,
    CONTACT_ME,
    DO_NOT_CONTACT,
    END_USER_CUSTOMER_FACILITY_NAME,
    END_USER_CUSTOMER_PHONE,
    END_USER_CUSTOMER_EMAIL,
    END_USER_CUSTOMER_FACILITY_ADDRESS,
    SAME_AS_PATIENT_ADDRESS,
    SAME_AS_REPORTER_ADDRESS,
    SAME_AS_END_USER_CUSTOMER_ADDRESS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_3,
    CONTACT_US,
    LANDING_BRIEF_FOR_DEVICE,
    PATIENT_SEX,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
    ATTENTION_NEEDED,
    SUBMIT_ERR_MSG,
    SUBMIT_RETRY_MSG,
    OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "製品フィードバックポータル";
translations[LANDING_BRIEF] = "オンラインVantive製品フィードバックポータルは、Vantiveの製品に関する機密情報とフィードバックの送信を目的としています。";
translations[LANDING_LANGUAGE_SELECTOR] = "言語の選択";
translations[LANDING_COUNTRY_SELECTOR] = "事象発生国を選択";
translations[LANDING_TERMS] = "バクスターの製品フィードバックポータルの利用規約とプライバシーに関する声明を読み、同意します。";
translations[LANDING_TERMS_ERROR] = "お客様は、バクスター製品フィードバックポータルの利用規約、プライバシーに関する声明、およびバクスター製品フィードバックポータルの追加利用条件およびプライバシーに関する声明の内容を読み、同意する必要があります。";
translations[LANDING_CAPTCHA_ERROR] = "あなたがロボットではないことを確認してください。";
translations[APP_DESCRIPTION] = "オンラインVantive製品フィードバックポータルは、製品に関する情報の送信を目的としています。 Vantive製品で問題が発生した場合は、そのイベントの詳細を共有することをお勧めします。 すべてのフィードバックは、製品と満足度を継続的に改善するための共有目標を達成するために不可欠です。";
translations[LANDING_TERMS_I_HAVE_READ] = "リンク先のVantive製品フィードバック ポータルのプライバシーに関する通知を読み、Vantive ヘルスケア コーポレーション (「Vantive」) が、プライバシーに関する通知に記載されている目的のために、私の個人データを使用、開示、処理することについて、私の同意を求めていることを理解しています。私は以下に同意します：";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "プライバシー通知に記載されている目的での私の個人データ（私が提供することを選択した健康関連データなどの機密データを含む）の使用、開示、保存、および処理。";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "私の個人データ（私が提供することを選択した健康関連データなどの機密データを含む）を、私の国外およびそれほど厳しくないか、データ保護法がない他の国に転送すること。";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "私は、この同意は任意であり、プライバシー通知に記載されている連絡先情報を使用してVantiveに連絡することにより、いつでも考えを変えて同意を取り消すことができることを理解しています。同意を撤回しても、撤回前の処理の合法性には影響しないことを理解しています。";
translations[MENU_FEEDBACK_FORM] = "製品フィードバックを始める";
translations[MENU_FEEDBACK_STATUS] = "製品フィードバックステータスを確認する";
translations[MENU_FORM_INTAKE] = "レポーター/連絡先";
translations[MENU_FORM_EVENT_DETAILS] = "イベント詳細";
translations[MENU_FORM_PRODUCT_INFO] = "製品情報";
translations[SYSTEM_FEEDBACK_FORM] = "製品フィードバックフォームを開始する";
translations[SYSTEM_FEEDBACK_STATUS] = "製品フィードバックステータスを確認する";
translations[SUBMIT_FEEDBACK] = "ここをクリックしてフィードバックを送信してください。";
translations[CHECK_SUBMITTED_FEEDBACK] = "ここをクリックして、以前に送信されたフィードバックのステータスを確認します。";
translations[BTN_LAUNCH_FORM] = "フォームを起動する";
translations[BTN_CHECK_STATUS] = "ステータスをチェック";
translations[FORM_TITLE] = "製品フィードバッグフォーム";
translations[FORM_SUB_TITLE] = "複数の患者が関与している場合は、患者ごとにフォームを記入してください。";
translations[FORM_MANDATORY_FIELDS] = "* の付いたフィールドはすべて必須です。";
translations[BUTTON_PREV] = "前へ";
translations[BUTTON_NEXT] = "次へ";
translations[BUTTON_SUBMIT] = "送信";
translations[SELECT_RESPONSE] = "レスポンスの選択";
translations[FUNCTION_ROLE] = "機能/役割";
translations[CUSTOMER_ACCOUNT_NUMBER] = "カスタマーアカウント番号";
translations[ENTER_CUSTOMER_ACCOUNT] = "顧客アカウントを入力";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "報告された事象に関与した顧客番号は何ですか。";
translations[EVENT_REPORTED] = "この事象は（Vantiveまたは他の報告機関）以前に報告されていますか？";
translations[REFERENCE_NUMBER] = "この事象に関連付けられた参照番号";
translations[ENTER_REFERENCE] = "参照を入力";
translations[WHO_REPORTED_TO] = "これは誰に報告されたのですか？";
translations[WHO_WAS_NOTIFIED] = "通知された人の名前を提供してください";
translations[ENTER_NAME] = "名前を入力";
translations[YOUR_NAME] = "名前";
translations[OCCUPATION] = "職業";
translations[PHONE_NUMBER] = "電話番号";
translations[ENTER_PHONE_NUMBER] = "電話番号を入力";
translations[ENTER_EMAIL] = "メールを入力";
translations[EMAIL_ADDRESS] = "メールアドレス";
translations[ENTER_ADDRESS] = "電子メールアドレスを入力する";
translations[ENTER_NA_IF_UNKNOWN] = "不明な場合は NA を入力してください。";
translations[FACILITY_HOSPITAL] = "施設/病院またはディストリビューター名 (該当する場合)";
translations[ENTER_FACILITY] = "施設名を入力する";
translations[ADDRESS_1] = "住所１";
translations[ADDRESS_2] = "住所２";
translations[CITY] = "市";
translations[STATE] = "州";
translations[POSTAL_CODE] = "郵便番号";
translations[COUNTRY] = "国";
translations[END_USER_CUSTOMER] = "この事象はエンドユーザー/カスタマーによって発見されましたか。";
translations[ADDITIONAL_CONTACT_PERSON] = "追加の連絡担当者";
translations[ADDITIONAL_PHONE] = "追加の連絡先電話番号";
translations[ADDITIONAL_EMAIL] = "追加の連絡先メール";
translations[ANOTHER_FACILITY_ADDRESS] = "別の施設/住所を追加";
translations[ANOTHER_FACILITY_HOSPITAL] = "別の施設/病院名またはディストリビューター名 (該当する場合)";
translations[ANOTHER_ENTER_FACILITY] = "施設名を入力する";
translations[ANOTHER_ADDRESS_1] = "住所１";
translations[ANOTHER_ADDRESS_2] = "住所２";
translations[ANOTHER_CITY] = "市";
translations[ANOTHER_STATE] = "州";
translations[ANOTHER_POSTAL_CODE] = "郵便番号";
translations[ANOTHER_COUNTRY] = "国";
translations[LOT_SERIAL_NUMBER] = "ロット番号/シリアル番号";
translations[ENTER_LOT_SERIAL_NUMBER] = "ロット番号/シリアル番号を入力";
translations[HELP_LOT_SERIAL_NUMBER] = "ロット/シリアル番号が不明の場合または顧客に尋ねても回答がなかった場合は「不明」と入力してください。";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "製品コード";
translations[PRODUCT_CODE] = "製品コード";
translations[ENTER_PRODUCT_CODE] = "製品コードを入力";
translations[HELP_PRODUCT_CODE] = "製品コードが不明の場合または顧客に尋ねても回答がなかった場合は「不明」と入力してください。";
translations[NDC] = "ナショナル・ドラッグ・コード (NDC) 番号";
translations[ENTER_NDC] = "NDCに入る";
translations[UDI] = "デバイス識別（UDI）";
translations[ENTER_UDI] = "UDI を入力";
translations[PRODUCT_NAME] = "商品名";
translations[ENTER_PRODUCT_NAME] = "製品名を入力";
translations[HELP_PRODUCT_NAME] = "製品の名前を入力してください。";
translations[BEST_DESCRIBES] = "報告された問題を最もよく表すものを選択してください";
translations[QUANTITY_TO_SELECT] = "数量";
translations[ENTER_QUANTITY] = "数量を入力";
translations[HELP_QUANTITY] = "報告された問題のある製品の数";
translations[UNIT] = "単位";
translations[AVAILABLE_TO_RETURNED] = "報告された現品は解析のためにVantiveに返品できますか？";
translations[PHOTOGRAPH_AVAILABLE] = "製品の写真やビデオは入手できますか？";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "報告された問題が写真またはビデオに表示されていることを確認してください。";
translations[UPLOAD_IMAGES] = "画像をアップロードする";
translations[REPORTER_NAME] = "報告者名";
translations[REPORTER_FACILITY] = "報告者の施設";
translations[REPORTER_OCCUPATION] = "報告者の職種";
translations[ENTER_NUMBER] = "番号を入力";
translations[REPORTER_PHONE_NUMBER] = "報告者の電話番号";
translations[REPORTER_EMAIL_ADDRESS] = "報告者ののメールアドレス";
translations[EMPLOYEE_NAME] = "従業員名";
translations[EMPLOYEE_PHONE_NUMBER] = "従業員の電話番号";
translations[EMPLOYEE_EMAIL_ADDRESS] = "従業員のメールアドレス";
translations[RETURNING_FOR_INVESTIGATION] = "調査のために返却された現品の数量（単位単位）";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "これらの現品は、報告された問題の製品でなければなりません。";
translations[UNUSED_VANTIVE_PRODUCT] = "同じロットの未使用のVantive製品を解析のために返送できるものはありますか？";
translations[YOU_INDICATED_SAMPLES] = "解析可能な現品を医療施設に持っていくことはできますか？";
translations[SAMPLE_RETURN_KIT] = "解析可能な現品を返却するための返品キットを送る住所を確認してください。";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "現品を返却するために、プリペイドラベルの付いた箱がこの住所に送られます。";
translations[SAME_AS_MY_ADDRESS] = "「住所」と同じ";
translations[OTHER_CONTACT_NAME] = "他の連絡先の名前";
translations[OTHER_CONTACT_OCCUPATION] = "その他の連絡先の職業";
translations[OTHER_CONTACT_PHONE_NUMBER] = "他の連絡先の電話番号";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "他の連絡先のメールアドレス";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "選択した製品は別の会社によって製造されています。レポートに関するその他の質問がある場合は、連絡先情報を提供できますか？";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "顧客は明確に調査結果を要求しましたか。";
translations[EXPLICITLY_REQUEST_CREDIT] = "顧客は明確に代替品を要求しましたか。";
translations[PRODUCT_FROM_VANTIVE] = "顧客はVantiveから直接製品を注文していますか？";
translations[QUANTITY_REQUESTED_CREDIT] = "代替品を要求するロット番号と数量:";
translations[ENTER_OCCUPATION] = "職業を入力する";
translations[LOT_QUANTITY_NUMBER] = "ロット番号と数量を入力してください";
translations[WHOLESALERS_NAME] = "代理店の名前と場所（市、州）は何ですか";
translations[PLACE_WHOLESALERS_NAME] = "代理店の名前と場所（市、州）は何ですか";
translations[ADD_PRODUCT_TO_THE_GRID] = "製品をグリッドに追加";
translations[SAVE] = "保存";
translations[CANCEL] = "キャンセル";
translations[ADD_MORE_PRODUCTS] = "製品をさらに追加";
translations[REPORTER_ADDRESS] = "報告者の住所";
translations[ATTACHMENTS] = "添付ファイル";
translations[DATE_OF_EVENT] = "事象発生の日付";
translations[DATE_OF_EVENT_MSG] = "事象発生の日付は、Vantive従業員に最初に通知された日付以降にはできません。 有効な日付を入力してください。";
translations[HELP_DATE_OF_EVENT] = "事象が発生した日付が複数ある場合は、各日付のフォームに記入してください。";
translations[DATE_VANTIVE_EMPLOYEE] = "Vantive従業員に最初に通知された日付";
translations[DURING_WHAT_PROCESS] = "事象はどのプロセスステップで発生しましたか。";
translations[WAS_THE_PATIENT] = "事象発生時に患者と製品は接続されていましたか（治療中）？";
translations[WERE_YOU_CONNECTED] = "事象発生時にあなたと製品は接続されていましたか（治療中）？";
translations[PROVIDE_ANY_ADDITIONAL] = "事象/問題に関連するその他の詳細を入力してください。";
translations[HELP_YOU_IDENTIFIED_MORE] = "複数の製品と問題を特定しました。どの製品に問題が報告されたかを明確にしてください。";
translations[ENTER_DETAILS] = "詳細を入力";
translations[PROVIDE_ANY_ATTACHMENT] = "必要に応じてファイルを添付する";
translations[WAS_NEGATIVE_MEDICAL] = "事象発生の結果として、医学的影響、症状、または傷害に悪影響はありましたか？";
translations[WAS_MEDICAL_INTERVENTION] = "報告された事象に対して、治療、医学的介入、またはケアのエスカレーションが行われましたか？";
translations[PROVIDE_DETAILS] = "詳細を提供してください";
translations[REQUIRED_TREATMENT] = "必要な治療/医療介入";
translations[ENTER_TREATMENT] = "治療を入力する";
translations[RELEVANT_TESTS] = "ラボデータを含む関連テスト：";
translations[HELP_RELEVANT_TESTS] = "関連するテストを入力する";
translations[RELEVANT_MEDICAL_HISTORY] = "既存の病状を含む関連する病歴：";
translations[ENTER_HISTORY] = "履歴を入力";
translations[PATIENT_NAME] = "患者の名前";
translations[PATIENT_INITIALS] = "患者のイニシャルまたはフルネーム。複数の患者が関与している場合は、患者ごとにフォームを記入してください。";
translations[PATIENT_PHONE_NUMBER] = "患者電話番号";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "提供なし";
translations[PATIENT_EMAIL_ADDRESS] = "患者メールアドレス";
translations[PATIENT_ADDRESS] = "患者住所";
translations[SAME_ADDRESS] = "同じ住所";
translations[DRUG_BEING_USED] = "事象発生時はVantiveの医薬品が使われていましたか？";
translations[PATIENT_IDENTIFIER] = "患者識別";
translations[PATIENT_AGE_OR_DOB] = "患者の年齢または生年月日";
translations[ENTER_PATIENT_AGE] = "mm/dd/yyyy、患者年齢を入力してください";
translations[PATIENT_GENDER] = "患者性別";
translations[PATIENT_WEIGHT] = "患者体重";
translations[ENTER_WEIGHT] = "体重を入力";
translations[PATIENT_WEIGHT_UNIT] = "患者体重単位";
translations[MY_NAME] = "名前";
translations[ENTER_IN_YOUR_CONTACT] = "連絡先情報を入力してください。";
translations[MY_PHONE_NUMBER] = "電話番号";
translations[MY_EMAIL_ADDRESS] = "メールアドレス";
translations[MY_ADDRESS] = "住所";
translations[NAME_OF_VANTIVE_DRUG] = "Vantive医薬品名";
translations[ENTER_DRUG_NAME] = "薬名を入力";
translations[PLEASE_PROVIDE_THE_NAME] = "Vantive Drugの名前または製品コードを提供してください。報告された問題の時点​​で使用されていたすべてのVantiveの薬物の名前を提供してください";
translations[SELECT_THE_COMPONENT] = "問題のあるコンポーネントを選択します。";
translations[USE_THE_DIAGRAM] = "上の図 (図1) を使用して、ディスポーザブル製品の破損した場所を特定します。";
translations[TYPE_OF_DAMAGE] = "損傷の種類を説明してください";
translations[PLEASE_ENTER_VALUE] = "値を入力してください";
translations[WAS_THE_PRODUCT_KINKED] = "製品がねじれたり、ひび割れたり、曲がったり、切れたりしましたか？";
translations[WERE_ANY_CLEANING] = "製品に洗浄液、溶剤、消毒剤が使用されていましたか？";
translations[WHAT_WAS_THE_DISINFECTANT] = "消毒剤の名前/ブランドは何でしたか、またどのように使われましたか？";
translations[NOTE_VANTIVE_LABELING] = "Vantive表示状態では、漂白剤、過酸化水素、アルコールまたはアルコールを含む消毒剤を使用しないよう記載があります。 これらの製品を使用すると、製品に亀裂が発生する可能性があります。";
translations[SELECT_ALL_THAT_APPLY] = "該当するものをすべて選択してください";
translations[DID_FOLLOWING_OCCUR] = "次のいずれかが発生しましたか。";
translations[SELECT_THE_LOCATION] = "ミニキャップでダメージのある場所を選ぶ";
translations[WAS_THE_PRODUCT_EXPOSED] = "問題が発生する前に、製品が過度の力 (つまり、ぶつかった、ぶつかった、衝突など) にさらされましたか？";
translations[HOW_LONG_TRANSFER] = "転送セットはどのくらいの期間使用されていますか？";
translations[WAS_THERE_DIFFICULTY] = "ツイストクランプを開閉するときに何か困難はありましたか？";
translations[WAS_DEVICE_OR_TOOL] = "ツイストクランプの開閉にデバイスやツールを使用しましたか？";
translations[DESCRIBE_HOW_PRODUCT] = "製品の使いづらい方法を説明する (該当するものをすべて選択)";
translations[DID_YOU_OBSERVE] = "製品に何らかの損傷（切れ、穴、亀裂など）が見られましたか？";
translations[WERE_DIFFICULTIES_PUTTING] = "ミニキャップをトランスファーセットに装着し、しっかりと固定されるまで時計回りにねじれるのが難しいことはありましたか？";
translations[WAS_THE_TRANSFER] = "このイベントが原因で、転送セットは置き換えられましたか？";
translations[SELECT_TYPE_OF_FLOW] = "フロー問題のタイプを選択";
translations[WAS_ANYTHING_BLOCKING] = "流れを妨げる何かあったっけ？";
translations[WAS_ANY_ALARM] = "警報はなかった？";
translations[SELECT_BEST_DESCRIBE] = "問題を最もよく説明するオプションを選択してください";
translations[WERE_THE_MINICAPS] = "ミニキャップは、高温/低温の環境で暴露または保管されていましたか？";
translations[WAS_THE_SPONGE_VISIBLE] = "ミニキャップの中にスポンジが見えましたか？";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "粒子状物質/異物はどこにありますか？";
translations[DESCRIBE_THE_EXACT_LOCATION] = "粒子状物質/異物の正確な位置、サイズ、形状、色を説明してください。";
translations[WAS_THE_PARTICULATE_MATTER] = "粒子状物質/異物は製品に埋め込まれていましたか？";
translations[DOES_THE_PARTICULATE_MATER] = "微粒子母材/異物は製品材料の一部であるように見えますか？";
translations[WHAT_COMPONENT_DOES] = "微粒子はどの成分から見えるのですか？";
translations[SELECT_CONNECTION_ISSUE] = "接続の問題を最もよく説明するオプションを選択します。";
translations[WERE_ASSIST_DEVICES] = "ディスポーザブル接続にアシストデバイスやツールが使われていましたか？";
translations[WERE_ANY_DIFFICULTIES] = "最初の接続中に問題が発生したか、切断されていましたか？";
translations[PROVIDE_PRODUCT_INFORMATION] = "接続の問題に関与した 2 番目の製品の製品情報を入力します。";
translations[WERE_THE_SPIKE_LUER] = "スパイク/ルアーコネクタは、しっかりと固定されるまで時計回りに回転しましたか？";
translations[VANTIVE_LABELING_STATES] = "Vantiveのラベルは、治療を開始する前に、すべての使い捨てセット接続が安全かつ適合していることを保証するために記載されています。";
translations[WERE_PETS_OR_ANIMALS] = "使い捨てセットにダメージを与えた可能性のあるペットや動物はいましたか？";
translations[VANTIVE_LABELING_CONTAMINATION] = "Vantiveラベリングでは、ペットや動物が使い捨て用品に噛まれた場合、流体経路の汚染が引き起こされる可能性があると述べています。 このリスクを減らすために、ペットや動物と同じ部屋で透析を行わないでください。";
translations[WERE_OTHER_ISSUES] = "スパイク/ルアーに関連する他の問題や困難（ひび割れ、変形、曲がったなど）はありますか？";
translations[WAS_MINICAP_TWISTED] = "ミニキャップは、しっかりと固定されるまで、トランスファーセットコネクタに時計回りにねじれていましたか？";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "ミニキャップをトランスファーセットに装着するのが難しいことはありましたか？";
translations[DID_TRANSFER_SET_CONNECTORS] = "トランスファーセットコネクタには、スレッドに目に見える損傷や残留物がありましたか？";
translations[WHAT_WAS_THE_ALARM] = "アラームは何でしたか？";
translations[WHERE_OBSERVED_DAMAGE] = "観測された損傷はどこでしたか（該当するものをすべて選択）";
translations[SELECT_THE_TYPE_OBSERVED] = "観測された損傷のタイプを選択します（該当するものをすべて選択してください）。";
translations[DID_DAMAGE_CAUSE_LEAK] = "被害はリークを引き起こしましたか？";
translations[WAS_THE_SHIPPING_CARTON] = "出荷用カートンは鋭利な物で開けましたか？";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "観察されるフロー問題のタイプを選択";
translations[HOW_LONG_WAS_STORAGE] = "期限切れの製品が見つかるまでの保管期間はどれくらいですか？";
translations[WAS_THERE_AN_ADAPTER] = "製品に使用されているアダプタ、またはその他のデバイスはありますか？";
translations[NAME_AND_MODEL] = "アダプタやその他のデバイスの名前とモデルは何ですか？";
translations[NAME_VAPORIZER] = "気化器の名前とモデルは何ですか？";
translations[WAS_VIAL_INVERTED] = "バイアルに溶液を絞る前に、付属のバイアルが反転しましたか？";
translations[WHAT_VIAL_USED] = "バイアルの製品情報は何ですか？";
translations[DRUG_NAME_MANUFACTURER] = "医薬品名、製造所ー、バイアルサイズ";
translations[WERE_BREAK_FRANGIBLE] = "前後の動きを使ってfrangibleを適切に壊すことができましたか？";
translations[WAS_ALARM_ASSOCIATED] = "ノーフローに関連するアラームはありましたか。";
translations[WHAT_PART_DISCOLORED] = "変色すると報告された製品のどの部分ですか？ (該当するものをすべて選択してください)";
translations[DESCRIBE_DISCOLORATION] = "変色を説明してください（色、色相、色合い、色合いなどを説明してください）。";
translations[HOW_PRODUCT_STORED] = "製品はどのように保管されましたか？";
translations[DOES_DISCOLORATION_APPEAR] = "変色は不透明、かすみ、曇っているように見えますか、または円形/ハニカムのマーキングがありますか？";
translations[WHICH_CHAMBER_DISCOLORED] = "バッグの変色したチャンバーはどれですか？";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "ピールシールまたはチャンバー間脆性はすでに壊れている/作動していましたか？";
translations[WAS_DISCOLORATION_NOTICED] = "気化器サイトグラスを通して変色が気づいたのですか？";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "問題を具体的に説明するオプションを選択します。";
translations[WHAT_DEVICE_HAD_ALARM] = "アラームはどのデバイスですか？";
translations[WHAT_MISSING_MISASSEMBLED] = "欠落した、または誤って組み立てられたコンポーネントは何ですか";
translations[RECONSTITUTION_ISSUE] = "改憲問題のより具体的な説明を述べて";
translations[WHAT_MEDICATION_SOLUTION] = "製品を再構成した医薬品/溶液は何ですか？";
translations[WHAT_VOLUME_MEDICATION] = "再構成に使用された医薬品/溶液の量はどれくらいですか？";
translations[WHAT_DEVICES_RECONSTITUTION] = "再構成時に使用された他のデバイス（名前/製造元、針サイズ/ゲージなど）";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "製品は熱にさらされたのですか？";
translations[DESCRIBE_EXPOSURE] = "暴露（温度、どのくらいの期間など）を記述する";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "ソリューションをアクティブ化するためにどのような手法が使用されましたか？";
translations[WAS_DAMAGE_OBSERVED] = "アクティベーション前に製品に損傷が見られましたか？";
translations[DESCRIBE_THE_DAMAGE] = "ダメージを説明してください。";
translations[APPROXIMATELY_SOLUTION_POWDER] = "おおよそ、過充填または過剰充填された溶液または粉末の量はどれくらいですか？";
translations[WAS_LEAK_OBSERVED] = "漏れは観察されましたか？";
translations[WHAT_FEATUR_DIFFICULT_USE] = "製品のどのコンポーネントや特徴が使いにくいのですか？";
translations[HOW_WAS_DIFFICULT_USE] = "この製品はどのように使いづらかったのですか？";
translations[WHERE_MATTER_FOREIGN] = "粒子状物質/異物はどこにありますか？";
translations[DOES_PARTICULATE_MATTER] = "粒子状物質/異物は製品材料のように見えますか？";
translations[DESCRIBE_EXACT_LOCATION] = "粒子状物質/異物の正確な位置、色、サイズ、形状、質感を説明してください。";
translations[WAS_MATTER_FOREIGN] = "粒子状物質・異物が製品に埋め込まれていましたか（自由に動かない）？";
translations[WHEN_MATTER_FOREIGN] = "粒子状物質/異物が観察されたのはいつですか？";
translations[PROVIDE_INFORMATION_MEDICATION] = "追加した医薬品の商品情報を提供してください。";
translations[PRODUCT_NAME_CODE_NUMBER] = "製品名、製品コード、製品ロット番号、ブランド名";
translations[DESCRIBE_SPIKING] = "使用されたスパイクまたは再構成テクニックについて説明してください。";
translations[INCLUDE_NEEDLE] = "針のサイズ/ゲージ、スパイク/突刺の角度、試行回数を含む";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "どの管理セットまたは改憲装置が使用されたのですか？";
translations[INCLUDE_MANUFACTURER] = "製造元、製品名、製品コード、製品ロットを含める";
translations[WAS_MEDICATION_ADDITIVE] = "薬剤、添加剤、または再構成液が製品に追加されましたか？";
translations[WHAT_MEDICATION_ADDITIVE] = "どのような薬、添加剤、または再構成溶液が加えられましたか？";
translations[WHAT_STATE_OF_PRODUCT] = "曇り/沈殿物が観察されたときの製品の状態はどれくらいですか？";
translations[AFTER_UNITS_SAT] = "ユニットが座って室温に達した後、曇り/沈殿物は消えましたか？";
translations[DID_ATTEMPT_AGITATE] = "ユニットを攪拌しようとしましたか？";
translations[DID_PRECIPITATE_DISSOLVE] = "沈殿物は溶解しましたか？";
translations[WHAT_STORAGE_TEMPERATURE] = "製品の保管温度と条件はどれくらいですか？";
translations[PROVIDE_TEMPERATURE_LOCATION] = "温度、場所、オーバーポーチ/カートンの中または外に保管されているか、VSC /中間カートン、個々のユニットの情報を記入してください";
translations[ARE_TEMPERATURE_LOGS] = "製品が保管されている冷凍庫の温度ログは利用可能ですか？";
translations[LOGS_CAN_BE_ATTACHED] = "ログはこのフォームに直接添付できます（送信時に利用可能な場合）。";
translations[IS_THE_STORAGE_UNIT] = "ストレージユニット（冷凍庫または冷蔵庫）はキャリブレーションされ、温度制御されていますか？";
translations[HOW_PRODUCT_THAWED] = "製品はどのように解凍されましたか？";
translations[WHAT_STORAGE_CONDITIONS] = "製品の保管条件は何でしたか？ （温度、場所、オーバーポーチ/カートンの内側または外側保管）";
translations[WAS_ANY_DAMAGE] = "商品に損傷があったか、または問題が観察されましたか。";
translations[MORE_SPECIFIC_INFORMATION] = "より具体的な情報を提供してください。";
translations[WHAT_PURPOSE_INDICATION] = "患者に対する治療の目的/適応は何でしたか？";
translations[WHAT_ROUTE_ADMINISTRATION] = "行政のルートは何でしたか";
translations[WHAT_DATE_ADMINISTRATION] = "行政の日付と期間はいつですか？";
translations[WHAT_DOSAGE_STRENGTH] = "患者に投与された投与量/強度は何でしたか？";
translations[WAS_RECENT_PRESCRIPTION] = "最近の処方箋変更はありましたか";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "製品の保管/温度の詳細（保管場所、冷蔵庫、冷凍庫など）は何でしたか？";
translations[WERE_ANY_ADJUSTMENTS] = "投与前に溶液や添加物の調整はありましたか？";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "問題の最も適切な説明を選択します。";
translations[SELECT_LABELING_ISSUE] = "ラベリングに関する問題の最も適切な説明を選択します。";
translations[WAS_CONNECTION_SECURE] = "接続は安全で、完全に締め付けられていましたか？";
translations[WAS_EXPIRED_PRODUCT] = "期限切れの製品は患者に投与されましたか？";
translations[WAS_COMPONENT_DAMAGED] = "部品が破損していましたか？";
translations[WERE_ABNORMALITIES_DAMAGE] = "製品に異常や損傷が気づいたことはありましたか？";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "発注番号は何ですか？";
translations[WHAT_DATE_OF_ADMINISTRATION] = "行政の日は何でしたか？";
translations[WHAT_WAS_EXPIRATION_DATE] = "製品の有効期限は何でしたか？";
translations[DESCRIBE_WAS_INCORRECT] = "ラベルの誤り、不完全、欠落、判読できないもの、またはラベルに類似しすぎたものを説明してください。";
translations[WHAT_SCANNER_USED] = "どのようなスキャナが使用されたのですか？";
translations[WAS_OVERPOUCH_POUCH] = "スキャン中に製品はまだオーバーポーチ/ポーチに入っていましたか？";
translations[WHAT_BACKGROUND_COLOR] = "スキャン時の背景色は何でしたか";
translations[DO_ALL_OF_THE_LABELS] = "すべてのラベル（製品、箱/カートン、配送/配布）は同じ製品情報を持っていますか？";
translations[PRODUCT_INFORMATION] = "製品情報";
translations[IS_A_BARCODE_SCANNER] = "あなたの施設ではバーコードスキャナーが使われていますか？";
translations[HOW_ARE_THESE_PRODUCTS] = "これらの製品は施設内にどのように保管されていますか？";
translations[WHAT_INFORMATION_INCORRECTLY] = "スキャン時に正しく表示されなかった情報は何ですか？";
translations[WAS_THERE_LEAK] = "漏れや水分は観察されましたか？";
translations[WHERE_LEAK_OBSERVED] = "漏れはどこで観察され、どの成分が漏れていましたか？";
translations[WAS_FRANGIBLE_OBSERVED] = "frangible観測は壊れていましたか？";
translations[IS_MOISTURE_CLEAR] = "水分は透明ですか？";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "ディストリビューターは誰ですか";
translations[WHAT_MANUFACTURER_MEDICATION] = "バイアルの製造元、薬名、サイズは何ですか？";
translations[WHAT_GAUGE_NEEDLE] = "使用される針のゲージ、メーカー、およびサイトが穿刺された回数は何ですか？";
translations[WHAT_ADMINISTRATION_SET] = "使用された管理セットは何ですか。";
translations[WAS_DIFFICULTY_SPIKING] = "スパイキングは困難でしたか？";
translations[WERE_FOLLOWING_SCENARIOS] = "リークで次のシナリオが発生しましたか？";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "壊れやすいものは損傷や欠陥があることが観察されましたか？";
translations[WHAT_AMOUNT_PRESSURE] = "どの程度の圧力がかかり、何時間かかりましたか？";
translations[WAS_BAG_COMPLETELY] = "バッグは圧力カフに完全に正しく挿入されていましたか（圧力カフの片端はプレッシャーカフの外側ですか）？";
translations[WHAT_MANUFACTURER_MODEL] = "圧力カフのメーカー、モデル、サイズは何ですか？";
translations[WHAT_PRESSURE_PRIOR] = "リークが検出される前の圧力はどれくらいですか？";
translations[LIST_THE_VAPORIZER] = "気化器の製造業者および名前/モデルを列挙する";
translations[APPROXIMATELY_HOW_MUCH] = "およそ液体がこぼれたのはどれくらいですか？";
translations[WAS_THE_BOTTLE_DIFFICULT] = "ボトルは気化器に挿入するのが難しいですか？";
translations[WERE_VISIBLE_DEFECTS] = "目に見える欠陥はありましたか？";
translations[SELECT_THE_OPTION] = "接続の問題を最もよく説明するオプションを選択します。";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "接続の問題に関与した 2 番目の製品の製品情報を入力します。";
translations[WHICH_PART_SEPARATED] = "製品のどの部分が分離されていますか？";
translations[WHAT_COMPONENT_DISCOLORED] = "変色している成分は何ですか？";
translations[SELECT_DESCRIBES_DISCOLORATION] = "変色を最もよく表すオプションを選択します。";
translations[WAS_THE_SET_DISCOLORED] = "パッケージから取り出したときにセットが変色しましたか？";
translations[DID_SET_CHANGE_COLOR] = "薬を追加した後にセットの色が変わったのですか？";
translations[WHAT_MEDICATION_ADDED] = "色の変更前にどのような薬が加えられましたか？";
translations[WHERE_MATERIAL_LOCATED] = "粒子状物質/異物はどこにありますか？";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "粒子状物質/異物（外観/色/サイズ）を説明する：";
translations[WAS_EMBEDDED_PLASTIC] = "粒子状物質/異物がプラスチックに緩んでいるか、または埋め込まれていましたか？";
translations[WAS_THERE_A_PRECIPITATE] = "予想されなかった注入液/溶液の沈殿物や色の変化はありましたか？";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "セットを通して注入された医薬品/ソリューションは何ですか？";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "損傷はどこでしたか、どのコンポーネントに影響を受けたのですか（該当するものをすべて選択してください）。";
translations[WHAT_DAMAGE_ISSUE] = "観察された損傷/問題の種類は何ですか（該当するものをすべて選択してください）。";
translations[DID_ISSUE_RESULT] = "この問題でリークが発生しましたか？";
translations[WAS_PATIENT_CONNECTED] = "患者は製品に接続されていましたか？";
translations[WAS_PRODUCT_REPLACED] = "製品は新製品に置き換えられましたか？";
translations[WHICH_SITUATION_BEST] = "分離/接続の問題に最も適した状況はどれですか";
translations[SELECT_MOST_LABELING_ISSUE] = "ラベリングに関する問題の最も適切な説明を選択します。";
translations[WHAT_INFORMATION_DISPLAYED] = "どのような情報が表示されたのですか。";
translations[WHAT_SCANNER_WAS_USED] = "どのようなスキャナが使用されたのですか？";
translations[INCLUDE_THE_MODEL_NAME] = "モデル名を含める";
translations[WAS_PRODUCT_ORDERED] = "商品はVantiveまたは他の販売代理店から直接注文されたのですか？";
translations[WHERE_LEAK_COMING] = "リークはどこから来ていますか（該当するものをすべて選択してください）。";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "リークで次のシナリオが発生しましたか？";
translations[WAS_POWER_INJECTOR] = "この製品はパワーインジェクタと一緒に使用されましたか？";
translations[WHAT_INJECTOR_USED] = "どのパワーインジェクタが使用されたのですか？";
translations[MANUFACTURER_NAME_CODE_LOT] = "メーカー、製品名、製品コード、製品ロット";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "ラベルの誤り、不完全、欠落、判読不能または変更されたものを説明してください。";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "切断に関与した 2 番目の製品の製品情報を入力します。";
translations[WHICH_COMPONENTS_WERE_FOUND] = "クラックや破損があるのはどのコンポーネントですか？";
translations[DESCRIBE_CUT_HOLE_SLICE] = "カット、穴、またはスライスのあるチューブ上の正確な位置を説明してください。";
translations[WAS_LEAK_ORIGINATING] = "漏れは注射部位の開口部から発生していましたか";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "切断/接続の問題に関係した 2 番目の製品の製品情報を提供してください";
translations[WHICH_SPECIFIC_BONDED] = "分離されている特定の結合成分はどれですか？";
translations[WERE_VISIBLE_IRREGULARITIES] = "関連する製品/コンポーネントに目に見える不規則性/損傷はありますか";
translations[WAS_SUCCESSFUL_CONNECTION] = "正常な接続または切断は最終的に確立されましたか（製品を交換しなくても）";
translations[WAS_TOOL_USED_ASSIST] = "ツールは接続/切断の補助に使用されましたか？";
translations[WERE_LUER_CONNECTIONS] = "すべてのLuer接続は、使用前に安全であることを確認するためにチェックされていますか（ラベルコピーごと）";
translations[WAS_PRODUCT_SECURELY] = "切断する前に、製品が別の製品と安全に接続されていましたか？";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "フローの問題を最もよく説明する状況はどれですか";
translations[WHAT_FLOWING_BACKWARDS] = "後方に流れてたのは何ですか？";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "バックフローの開始位置から停止した場所までのコンポーネントについて説明します。";
translations[DO_SITUATIONS_APPLY] = "このイベントには、これらの状況のいずれかが当てはまりますか？";
translations[WHICH_SPECIFIC_AREA] = "フローの問題に関連していたセットまたはコンポーネントの特定の領域はどれですか。";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "フローは以前にセットまたはコンポーネントを通して見られましたか？";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "以下のいずれかが観察されましたか:";
translations[WHERE_SIMULTANEOUS_FLOW] = "その間の同時フローはどこでしたか";
translations[WHAT_TYPE_HANGER] = "どのようなタイプのハンガーが使われましたか？";
translations[WHAT_WAS_HANGER_LENGTH] = "ハンガーの長さやメーカーは何でしたか？";
translations[WHICH_BAG_LOWER] = "下のバッグはどれですか？";
translations[WHAT_Y_SITE_WAS] = "セカンダリセットはどの Y サイトに接続されましたか。";
translations[WHAT_COMPONENT_WITHIN] = "セット内のどの成分が溶液または血液から除去できないのですか？";
translations[WAS_COMPONENT_SET_REPLACED] = "コンポーネント/セットは、クリアできなかった後に交換されましたか。";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "患者に注入される液体の量と所定の期間は何でしたか？";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "患者に実際に注入された液体の量は、何期間でしたか？";
translations[WAS_USED_WITH_PUMP] = "セットはポンプで使われていましたか？";
translations[DID_CLAMP_FAIL] = "クランプが停止しなかったり、流れを制御したりしなかったのですか？";
translations[WHAT_CLAMP_FAILED] = "どのクランプが失敗しましたか？";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "クランプに問題はありましたか？";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "その他の状況では、製品に関する問題について説明していますか (該当するものをすべて選択してください)。";
translations[DESCRIBE_ALARM_OBSERVED] = "観測されたアラームを説明してください。";
translations[INCLUDE_ANY_MESSAGES] = "アラームに関連付けられているメッセージとエラーコードを含める";
translations[WHICH_CLAMP_HAD_ISSUE] = "問題があったクランプはどれですか？";
translations[WHICH_TYPE_CLAMP_ISSUE] = "発生したクランプの問題 (該当するものをすべて選択) はどれですか。";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "問題を最もよく説明するシナリオを選択します。";
translations[PROVIDE_MORE_DETAILS] = "製品の使用が困難だった方法の詳細を以下に示します。";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "フォローや理解が困難だった手順の詳細を記入してください。";
translations[DESCRIBE_THE_SMELL] = "匂いとそれがどこから来たのかを説明してください。";
translations[WAS_ISSUES_WITH_SET] = "セットで観察された問題はありましたか？";
translations[WHERE_LEAK_LOCATED] = "漏れは製品のどこにありますか？";
translations[DID_OCCUR_WITH_LEAK] = "リークで次のいずれかが発生しましたか？";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "切断に関与した 2 番目の製品の製品情報を入力します。";
translations[DID_OCCURRED_WITH_THE_LEAK] = "リークで次のシナリオが発生しましたか？";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "製品が破損したのはどこですか？";
translations[SELECT_ALL_APPLY] = "該当するものをすべて選択してください";
translations[DESCRIBE_OBSERVED_DAMAGE] = "観測された損傷を説明する";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "製品のどの成分が変色しましたか？";
translations[DESCRIBE_HUE_TINT_SHADE] = "観察された色（色相、色合い、色合いなど）を説明してください。";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "内部または外側のオーバーパウチ、温度、光への曝露など";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "粒子状物質/異物の正確な位置、サイズ、形状、色を説明してください。";
translations[DOES_THE_PARTICULATE_MATTER] = "粒子状物質/異物は製品材料に見えますか？";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "粒子状物質/異物は埋め込まれていましたか？";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "微粒子母材/異物は製品材料の一部であるように見えますか？";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "問題が発生したのは製品のどこですか。";
translations[LIST_COMPONENTS_IF] = "部品一覧を表示します。 2番目の製品が関与している場合は、製造元、製品名、製品コード、製品ロットを記載してください";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "目に見える不規則性/損傷は観察されましたか？";
translations[SELECT_OPTION_FLOW_ISSUE] = "フローの問題を最もよく説明するオプションを選択します。";
translations[DESCRIBE_IRREGULARITIES] = "不規則性/損傷、および接続/切断前に損傷が観察されたか、または接続/切断中に発生したかどうかを説明する";
translations[HOW_PRODUCT_SETUP] = "製品のセットアップはどうでしたか";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "ラベリングに関する問題の最も適切な説明を選択します。";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "ラベルの誤り、不完全、欠落、判読できないもの、またはラベルに類似しすぎたものを説明してください。";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "出荷用カートンの商品が破損していましたか？";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "受け取るはずの商品は何ですか？";
translations[IF_PRODUCT_CODE_NOT] = "製品コードが入手できない場合は、製品の説明を記入してください";
translations[WAS_THE_CASE_MISSING] = "ケースにドライアイスや冷蔵ジェルパックが欠けていましたか？";
translations[WHAT_CARRIER_DELIVERED] = "商品をお届けした配送業者はどれですか？";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "発注書番号は何ですか。";
translations[WHAT_QUANTITY_MISSING_UNITS] = "行方不明の商品の数量はどれくらいですか？";
translations[WAS_EXPIRED_PRODUCT_USE] = "期限切れの製品は使用されましたか？";
translations[APPLY_TO_EACH_UNIT] = "この事象に１つ以上の製品が関与している場合、以下の質問は各製品に該当します。";
translations[TERMS_CONDITIONS] = " 利用規約プラ";
translations[PRIVACY_POLICY] = "イバシーポリシ";
translations[PRIVACY_NOTICE] = "プライバシー通知";
translations[COOKIE_POLICY] = "クッキーポリシー";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "不明な質問";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Vantive従業員";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "介護者";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "ディストリビューター";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "ヘルスケアプロフェッショナル";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "患者";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "その他";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "使用後";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "使用前";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "準備中";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "治療中";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "複数処理中";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "指定なし";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "家族";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "看護師";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "看護師見習い";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "診療看護師";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "医師";
translations[OPTION_UNITOPTIONS_BOXES] = "ボックス";
translations[OPTION_UNITOPTIONS_PALLETS] = "パレット";
translations[OPTION_UNITOPTIONS_UNITS] = "ユニット";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "アラーム状態";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "破損";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "使用しにくい";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "変色";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "フローの問題";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "ラベル問題";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "リーク/過剰な水分";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "異物";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "患者反応/有害事象";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "製品問い合わせ";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "分離/接続";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "出荷問題/期限切れの製品";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "女性";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "未分化";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "男性";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "回答を拒否する";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "管理者/スーパーバイザー";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "バイオメディカルエンジニア";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "会社代表";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "歯科医";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "ディストリビューター";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "家族";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "患者";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "看護師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "看護師見習い";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "診療看護師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "薬剤師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "薬局技術者";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "医師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "患者";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "リスクマネージャー";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "その他";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "追加の連絡先";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "私に連絡して";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "その他へ連絡";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "中国 FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "カナダ保健省";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (日本)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (オーストラリア)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "ペットや動物が問題を引き起こした可能性がありました";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "箱やオーバーポーチを開けるために鋭利な物または工具を使用しました。";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "問題が発生する前に、製品が過度の力（叩く、ぶつかる、衝撃など）にさらされていました。";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "製品は高温/低温環境で暴露または保管されていました";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "カートン";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "ミニキャップ";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "パウチ";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "トランスファーセットがきつすぎました";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "トランスファーセットが緩すぎました";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "トランスファーセットは完全に閉じることができませんでした";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "トランスファーセットは完全に開くことができませんでした";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "ツイストクランプは非常にきつく、トランスファーセットがまったく開けませんでした";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "ツイストクランプは非常にきつく、トランスファーセットがまったく閉まりませんでした。";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "はい-転送セットのスレッドに損傷/何か問題があり、正しく閉じられませんでした";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "はい-Minicapは手で、またはツール/アシスト装置でトランスファーセットに締めすぎました";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "流体の流れなしで完全に停止";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "部分的に流れる（スローフロー）";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "凝固血液";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "フィブリン";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "キンク";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "異物";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "製品材料";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "接続時または包装内に過剰ヨウ素（茶色）がある";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "包装内に識別される余分な水分（透明な液滴）がある";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "開封前にフォイルパウチが破損している";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "パッケージを開ける前に箱またはパウチが破損している";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "スポンジが乾燥し白い";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "スポンジが乾燥し茶色い";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "二次包装/オーバーポーチ内側";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "製品内または流体経路の内側";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "出荷カートンの内側";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "製品の外側";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "二次包装/オーバーポーチの外側";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "出荷カートンの外側";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "製品を別の製品に接続できない";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "製品を別のプロダクトから切り離す困難";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "単一製品内の構成部品の分離";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "別の製品との製品の分離/切断";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "はい-スレッドに残留物";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "はい-外観破損";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "はい-その他（フリーテキスト）";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "フランジブル";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "ハンガーほーる";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "注入/充填ポート";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "メンブレンポート";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "オーバーポーチ/ポーチ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "パッチ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "ゴムストッパー";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "出荷カートン";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "収縮バンド";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "ソリューションコンテナ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "チッププロテクター";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "改ざん防止シール（シュリンクラップ）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "曲がリ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "破損";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "割れ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "カット";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "変形";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "フレ―キング";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "穴";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "キンク";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "溶けている";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "パッチ層分離";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "粉々になった（ガラス）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "スライス";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "破れ";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "まったく流れない";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "非常にゆっくりと流れる";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "再構成または配合中に溶液は流れない（またはゆっくり流れる）";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "ボトル";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "コンテナ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "ハンガーホール";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "ライナー";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "オーバーポーチ/ポーチ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "酸素インジケーター";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "パッチ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "ポート";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "ソリューション";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "チッププロテクター";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "アミノ酸チャンバー";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "デキストロースチャンバー";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "脂質チャンバー";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "下室チャンバー";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "上部チャンバー";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "バースト/破裂シール";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "組み立て不良-製品/部品";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "部品がない";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "結合構成部品の分離/切断 ";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "製品オーバー充填";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "製品未充填";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "再構成問題";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "二次包装/オーバーポウチの内側";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "出荷カートンの内側";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "出荷カートンの外側";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "内部溶液/流体経路";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "気化器内（サイトグラス）";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "製品の外面";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "二次包装/オーバーポーチの外側";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "側酸素吸収材";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "経皮パッチ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "フランジブル";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "ガラス粒子";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "ポート";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "ラバーストッパー";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "チューブ";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "別の薬を追加した後、または再構成後（バイアル）";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "スパイクまたは再構成の前";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "冷たい（解凍したがまだ室温ではない）";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "凍結";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "部分解凍（溶液中の氷結晶）";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "室温";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Vantive解凍ユニット (VTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = " 室温でカウンターに放置";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "冷蔵庫";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "はい- 出荷中に損傷の証拠がありました";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "はい-漏れが観察されました";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "はい-オーバーポーチに穴または不完全なシールがありました";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "はい-スパイクまたは再構成が困難でした";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "はい-フランジを壊すのが困難でした";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "はい-結晶化または沈殿がありました";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "はい-フローズンギャラクシー製品に曇り/沈殿物がありました";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "製品が意図した効果をもたらさなかったり、効果がない（効果がない）";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "意図しない効果/反応。 指定してください:(フリーテキスト)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "配送中の輸送箱が破損しています";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "期限切れの製品配達";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "期限切れの製品が見つかった";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "バーコードの問題- スキャン時に誤った情報が表示される";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "スキャン不能/スキャンできないバーコード";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "期限切れの製品";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "納品期限切れの商品が在庫にある";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "ラベルが読みにくい";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "ラベルが正しくない";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "不完全なラベル";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "ラベルラベルが別の商品と類似している";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "ラベル (商品、箱/カートン、配送リスト) に同じ商品情報が記載されていません";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "バーコードがない";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "カートン/箱に間違った製品が含まれているか、または混合されている";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "配送中に輸送箱が破損している";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "余分なユニットを受け取った";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "期限切れの商品が配達された";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "期限切れの製品が見つかりました";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "カートンの一部が開いているか密封されていない";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "カートンと配送ラベルの商品情報がカートンの中の商品と一致しません";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "製品ユニットが欠落または過剰";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "ラベルがない";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "有効期限";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "ロット番号";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = " NDC 番号";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "水滴、オーバーパウチ内の過剰水分";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "漏れ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "バッグを押したときの漏れ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "微量な溶液の流れ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "オーバーパウチ内部の水分であり、漏れではない";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "オーバーポーチと一次容器の間";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "2つの製品間の接続";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "コンテナ- メンブレンポート/チューブ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "コンテナ- 注入/充填ポート";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "コンテナ-ハンガー穴";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "コンテナ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "フランジブル";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "ゴムストッパー";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "収縮";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "チッププロテクター";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "不明";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "バイアルアダプター";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "ポートの付着";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "二次包装または中間カートンへの損傷（穴、破れ）";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "極端な高温/低温にさらす";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "気化器でのリーク";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "カッター/鋭利な物体で出荷カートンを開く";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "ペット（閉め/噛んだ）";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "圧力カフまたは他の装置による圧力下でのソリューションバッグ接着ポート";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "ポートの付着";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "二次包装または中間カートンへの損傷（穴、破れ）";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "配送中の損傷輸送カートンボックス";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "極端な高温/寒さにさらされた";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "気化器でのリーク";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "輸送カートンボックをスカッター/鋭利な物で開けた";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "ペット（閉め/噛んだ）";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "圧力カフまたは他の装置による圧力下でのソリューションバッグ接着ポート";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "上記のいずれにも当てはまらない";
translations[NO_DESCRIBE_THE_COLOR] = "いいえ-色（フリーテキスト）";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = " 1-10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = " より大きい 10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "1mL未満";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "ボトル";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "キャップ";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "バルブ/ネック";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "なし";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "製品を別の製品に接続できない";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "製品を別のプロダクトから切り離す困難";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "単一製品内の構成部品の分離";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "別の製品との製品の分離/切断";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "ドリップチャンバー";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "チューブ";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "その他-指定してください (フリーテキスト)";
translations[OTHER_PLEASE_SPECIFY] = "その他-指定してください (フリーテキスト)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "白/曇っている";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "黄色/茶色";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "その他-指定してください（フリーテキスト）";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "一次包装/ブリスターパウチ内";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "IV流体経路の内側（チューブ内）";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "出荷カートンの内側";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "出荷用カートンの外側";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "IV流体経路の外側（チューブの外側）";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "埋め込み";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "緩い";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "適用不可";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "はい- 色の変化色の説明色 (フリーテキスト)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "はい- 変色";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "はい- 沈殿";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "アクセスサイト";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "バレット";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "クランプ";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "ドリップチャンバー";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "チューブ";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "不明";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "フィルター";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "ルアーコネクタ";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "スパイク";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "切断/ひび割れ/破断された構成部品";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "アセンブリが正しくありません- 指定してください (フリーテキスト)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "キンク/折りたたんだ構成部品";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "パッケージの内側構成部品の緩み/外れ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "不良/形状が間違っているコンポーネント";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "欠落コンポーネント";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "プロダクトを別のプロダクトに接続することが困難";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "2つのプロダクトの切り離しができない";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "製品接続緩い";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "プロダクトを別のプロダクトから分離/切断";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "1つのプロダクト内の2つの結合された構成部品の分離";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "2つのプロダクトを一緒に接続できない";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "別のプロダクトからのプロダクトの切断切断ができません";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "バーコードの問題- スキャン時に誤った情報が表示される";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "ラベル変更";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "スキャン不能";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "使用期限切れ製品";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "ラベルに誤った情報がある";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "バーコード不足/UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "ラベルに情報の欠落があった";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "バーコード製品ラベルに有効期限がない";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "ラベルに汚れ、判読不能があった";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "カートン/箱に間違った製品が含まれているか、または混合商品が見つからない";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "配送中に輸送箱が破損している";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "期限切れの商品が配達された";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "期限切れの製品が見つかりました";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "ディストリビューター";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "余分なユニットが受領されました";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "カートンの一部が開封されているか密封されていない";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "カートンと配送ラベルの商品情報がカートンの中の商品と一致しません";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "ユニットがない";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "アクセスサイト";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "エアベント";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "ビュレット";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "キャップ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "クリアリンク射出部位";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "クランプ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "ドリップチャンバー";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "フィルター";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "インターリンク注射部位";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "ルアーコネクタ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "スパイク";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "チューブ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "不明";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = " 射出間の漏れ外構とチューブ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "ニードルベースの注入部位";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "ワンリンク注入部位";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "その他の射出部位 (フリーテキスト)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "の切断硬質セットコンポーネントの割れ/破れ";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "ソフトチューブのカット/スライス";
translations[DISCONNECTION_OF_CONNECTABLE] = "可能コンポーネント/接続プロダクト";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "可能コンポーネント/接続プロダクト";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "ボンディングコンポーネントの分離接続";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "はい-不規則性/損傷を説明する（フリーテキスト）";
translations[YES_SPECIFY_THE_TOOL] = "はい-使用するツールを指定してください (フリーテキスト)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "逆流";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "クランプ故障-クランプが難しい（しかし最終的に閉じることができる）";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "クランプ故障- 完全にクランプ故障を閉じることができない";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "クランプ故障-困難または開けることができない";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "フロー制限なし";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "流速速い";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "スローフロー";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "同時フロー";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "注入下での注入過剰成分をクリアできない";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "プライミングができない";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "流速遅い";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "患者の血液（輸液中の血液製剤ではない）";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "ソリューション/血液製品";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "漏れ　破損/破れ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "接続外れ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "漏れ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "投薬は加圧注入か";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "シリンジまたはIVポンプか";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "二次バッグがプライマリバッグよりも低かった";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "血液凝固";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "取り付ける前にカテーテルを洗い流すことができなかった";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "チューブキンク";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "注射部位の閉塞";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "一次および二次容器（ピギーバック）";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "マルチリードセットに流れる2つ以上のリード";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "自の輸液ポンプでそれぞれ2つの管理セット";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Vantiveハンガー";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "非Vantiveハンガー";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "バッグは同じ高さにあった";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "一次";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "二次";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "ミドル";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "ロワー";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "アッパー";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "はい-ポンプの名前と製品コードを入力してください (フリーテキスト)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "ダークブルースライドクランプ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "ライトブルースライドクランプ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "ノッチクランプ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "ローラークランプ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "ホワイトスライドクランプ";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "はい- クランプが壊れているかひびが入った";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "エアインライン";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "クランプ問題";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "臭気";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "ノッチ/ピンチ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "ローラークランプ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "スライドクランプ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "割れ/壊れている";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "開くのが難しい";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "閉じるのが難しい";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "見当たらない";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "開けことができない";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "閉じることができない";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "フローを制御できません";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "絞りにくいドリップチャンバー";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "説明書がわかりにくかった";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "製品は使いづらかった";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "切断/破損";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "カット/スライス";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "可能コンポーネント/接続プロダクト";
translations[DISCONNECTION_OF_CONNECTABLE] = "可能コンポーネント/接続プロダクト";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "穴/破れ";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "接合部品の分離";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "ポートの付着";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "二次包装または中間カートンへの損傷（穴、破れ）";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "配送中の損傷";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "極端な高温/寒さにさらされた";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "輸送カートンボックをスカッター/鋭利な物で開けた";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "不明";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "上記のいずれにも当てはまらない";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "圧力カフまたは圧力インジェクター使用接着ポート";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "ポートの付着";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "ペット（閉め/噛んだ）";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "商品";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "配送カートン/ボックス";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "商品の内側";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "出荷カートン内側";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "製品の外側";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "製品を別のプロダクトに接続できない";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "プロダクトを別のプロダクトから切り離す困難";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "緩い接続";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "単一プロダクト内の構成部品の分離";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "別のプロダクトとの分離/切断";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "出荷カートンの外側";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "二次包装/オーバーパウチの内側";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "二次包装/オーバーパウチーチの外側";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "流れない";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "制限または部分的に流れない";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "バーコードの問題- スキャン時に誤った情報が表示される";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "スキャン/スキャン不能バーコードラベル";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "ラベルが読みにくい";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "ラベルが正しくない";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "不完全なラベル";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "（商品、箱/カートン、配送リスト）に同じ情報がない";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "ラベルが別の商品と類似しすぎます";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "ラベルがない";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "バーコード不足の問題";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "凍った製品が届いた";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "解凍された製品が届いた";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "はい、アラームは不明";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "はい、指定 ";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "はい-転送セットを完全に開けることができませんでした";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "はい-転送セットを完全に閉じることができませんでした";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "はい-ツイストクランプは非常にきつく、トランスファーセットがまったく開けませんでした";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "はい-ツイストクランプは非常にきつく、トランスファーセットがまったく閉まりませんでした。";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "ボックスまたはオーバーパウチ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "最終充填ラインのブルークランプ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "カセット";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "排水ラインコネクタとプルリングキャップ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "排液サイト";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "供給ライン";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "ルアー/スパイクコネクタ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "オーガナイザー";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "患者ライン上のプルリングキャップ/チッププロテクター";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "プルリングキャップ/チッププロテクター";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "ヒーターライン上の赤いクランプ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "タックウェルド";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "供給ラインのホワイトクランプ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "ベージュカテーテルアダプター";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "インサートチップ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "ダークブルーコネクタ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "ライトブルー本体";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "コネクタ-ライトブループルリングキャップ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "ライトブルー内足";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "シリコンチューブ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "チタンスパイク";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = " UVフラッシュスパイク";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "ホワイトツイストクランプ/スリーブ";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "はい：損傷を説明する（フリーテキスト）";
translations[OPTION_MONTHOPTIONS_JAN] = "1月";
translations[OPTION_MONTHOPTIONS_FEB] = "2月";
translations[OPTION_MONTHOPTIONS_MAR] = "3月";
translations[OPTION_MONTHOPTIONS_APR] = "4月";
translations[OPTION_MONTHOPTIONS_MAY] = "5月";
translations[OPTION_MONTHOPTIONS_JUN] = "6月";
translations[OPTION_MONTHOPTIONS_JUL] = "7月";
translations[OPTION_MONTHOPTIONS_AUG] = "8月";
translations[OPTION_MONTHOPTIONS_SEP] = "9月";
translations[OPTION_MONTHOPTIONS_OCT] = "10月";
translations[OPTION_MONTHOPTIONS_NOV] = "11月";
translations[OPTION_MONTHOPTIONS_DEC] = "12月";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "その他";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "その他";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "その他（フリーテキスト）";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "その他（フリーテキスト）";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "上記のいずれにも当てはまらない";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "いいえ";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "はい";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "いいえ";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "はい";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "いいえ";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "はい";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "いいえ";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "はい";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "不明な質問";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "いいえ";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "不明";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "はい";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "いいえ";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "はい";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "いいえ";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "はい";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "いいえ";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "不明";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "はい";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "いいえ";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "はい";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "いいえ";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "はい";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "いいえ";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "はい";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "いいえ";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "はい";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "いいえ";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "はい";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "いいえ";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "はい";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "いいえ";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "はい";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "いいえ";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "はい";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "いいえ、";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "はい";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "いいえ";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "不明";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "はい";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "いいえ";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "いいえ";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "はい";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "いいえ";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "はい";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "いいえ";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "はい";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "いいえ";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "はい";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "いいえ";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "はい";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "いいえ";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "はい";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "いいえ";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "はい";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "いいえ";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "はい";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "いいえ";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "はい";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "いいえ";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "不明";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "はい";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "いいえ";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "いいえ";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "はい";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "いいえ";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "はい";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "いいえ";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "はい";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "いいえ";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "不明";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "はい";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "いいえ";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "はい";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "いいえ";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "はい";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "いいえ";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "はい";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "いいえ";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "はい";
translations[OPTION_vaporizerSightGlassOptions_NO] = "いいえ";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "不明";
translations[OPTION_vaporizerSightGlassOptions_YES] = "はい";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "いいえ";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "はい";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "いいえ";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "はい";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "いいえ";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "はい";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "いいえ";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "はい";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "いいえ";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "はい";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "いいえ";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "不明";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "はい";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "いいえ";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "不明";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "はい";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "いいえ";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "はい";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "いいえ";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "不明";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "はい";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "いいえ";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "不明";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "はい";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "いいえ";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "はい";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "いいえ";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "はい";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "いいえ";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "はい";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "いいえ";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "不明";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "はい";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "いいえ";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "はい";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "いいえ";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "不明";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "はい";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "いいえ";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "はい";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "いいえ";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "はい";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "いいえ";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "不明";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "はい";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "不明";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "はい";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "いいえ";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "はい";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "いいえ";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "はい";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "いいえ";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "はい";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "いいえ";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "不明";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "はい";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "いいえ";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "はい";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "いいえ";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "はい";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "いいえ";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "はい";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "いいえ";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "はい";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "いいえ";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "不明";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "はい";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "いいえ";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "不明";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "はい";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "いいえ";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "いいえ";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "はい";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "いいえ";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "いいえ";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "はい";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "いいえ";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "不明";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "はい";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "いいえ";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "不明";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "はい";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "いいえ";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "はい";
translations[OPTION_WITHPUMPOPTIONS_NO] = "いいえ";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "不明";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "いいえ";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "不明";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "はい";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "いいえ";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "いいえ";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "はい";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "いいえ";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "不明";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "はい";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "いいえ";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "はい";
translations[OPTION_GELPACKSOPTIONS_NO] = "いいえ";
translations[OPTION_GELPACKSOPTIONS_YES] = "はい";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "いいえ";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "はい";
translations[OPTION_ALARMOPTIONS_NO] = "いいえ";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "不明";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "いいえ";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "不明";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "はい";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "いいえ";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "不明";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "いいえ";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "はい";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "いいえ";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "はい";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "いいえ";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "不明";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "いいえ";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "不明";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "はい";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "その他 (フリーテキスト)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "いいえ";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "はい";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "いいえ";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "はい";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "いいえ";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "はい";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "不明な質問";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "不明な質問";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "不明";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "いいえ";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "不明";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "上記のいずれにも当てはまらない";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "いいえ-色（フリーテキスト）";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "不明";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "不明";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "はい-使用するツールを指定してください (フリーテキスト)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "外れ";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "なし";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "不明";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "はい-その他（フリーテキスト）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "不明";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "なし";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "キログラム";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "ポンド";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "いいえ";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "不明";
translations[PLEASE_ENTER_THE_VALUE] = "値を入力してください";
translations[PLEASE_SELECT_THE_VALUE] = "値を選択してください";
translations[PLEASE_SELECT_THE_DATE] = "日付を選択してください。";
translations[PLEASE_CHOOSE_THE_VALUE] = "値を選択してください";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "不明";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "イギリス";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "コソボ";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "北アイルランド";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "アフガニスタン";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "オーランド諸島";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "アルバニア";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "アルジェリア";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "アメリカ領サモア ";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "アンドラ";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "アンゴラ";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "アングィラ";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "南極大陸";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "アンティグア・バーブーダ";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "アルゼンチン";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "アルメニア";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "アルバ";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "オーストラリア";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "オーストリア";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "アゼルバイジャン";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "バハマ";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "バーレーン";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "バングラデシュ";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "バルバドス";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "ベラルーシ";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "ベルギー";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "ベリーズ";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "ベナン";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "バミューダ";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "ブータン";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "ボリビア";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "ボスニア・ヘルツェゴビナ";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "ボツワナ";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "ブーベ島";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "ブラジル";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "イギリス領インド洋地域";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "ブルネイ";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "ブルガリア";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "ブルキナファソ";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "ブルンジ";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "カンボジア";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "カメルーン";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "カナダ";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "カーボベルデ";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "ケイマン諸島";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "中央アフリカ共和国";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "チャド";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "チリ";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "中国";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "クリスマス島";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "ココス諸島";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "コロンビア";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "コモロ";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "コンゴ共和国";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "コンゴ民主共和国";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "クック諸島";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "コスタリカ";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "コートジボワール ";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "クロアチア";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "キューバ";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "キプロス";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "チェコ共和国";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "デンマーク";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "ジブチ";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "ドミニカ国";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "ドミニカ共和国";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "エクアドル";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "エジプト";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "エルサルバドル";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "赤道ギニア";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "エリトリア";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "エストニア";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "エチオピア";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "フォークランド諸島 ";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "フェロー諸島";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "フィジー";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "フィンランド";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "フランス";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "フランス領ギアナ";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "フランス領ポリネシア";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "フランス領南方・南極地域";
translations[OPTION_COUNTRYOPTIONS_GABON] = "ガボン";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "ガンビア";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "ジョージア";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "ドイツ";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "ガーナ";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "ジブラルタル";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "ギリシャ";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "グリーンランド";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "グレナダ";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "グアドループ";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "グアム";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "グアテマラ";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "ガーンジー島";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "ギニア";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "ギニアビサウ";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "ガイアナ";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "ハイチ";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "ハード島とマクドナルド諸島";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "バチカン";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "ホンジュラス";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "香港";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "ハンガリー";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "アイスランド";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "インド";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "インドネシア";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "イラン";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "イラク";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "アイルランド";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "マン島";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "イスラエル";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "イタリア";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "ジャマイカ";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "日本";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "ジャージー島";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "ヨルダン";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "カザフスタン";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "ケニア";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "キリバス";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "北朝鮮";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "韓国";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "クウェート";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "キルギス";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "ラオス";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "ラトビア";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "レバノン";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "レソト";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "リベリア";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "リビア";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "リヒテンシュタイン";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "リトアニア";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "ルクセンブルク";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "マカオ";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "マケドニア旧ユーゴスラビア共和国";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "マダガスカル";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "マラウイ";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "マレーシア";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "モルディブ";
translations[OPTION_COUNTRYOPTIONS_MALI] = "マリ";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "マルタ";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "マーシャル諸島";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "マルティニーク";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "モーリタニア";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "モーリシャス";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "マヨット";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "メキシコ";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "ミクロネシア連邦";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "モルドバ";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "モナコ";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "モンゴル";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "モンテネグロ";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "モントセラト";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "モロッコ";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "モザンビーク";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "ミャンマー";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "ナミビア";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "ナウル";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "ネパール";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "オランダ";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "ニューカレドニア ";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "ニュージーランド";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "ニカラグア";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "ニジェール";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "ナイジェリア";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "ニウエ";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "ノーフォーク島";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "北マリアナ諸島";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "ノルウェー";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "オマーン";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "パキスタン";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "パラオ";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "パレスチナ";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "パナマ";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "パプアニューギニア";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "パラグアイ";
translations[OPTION_COUNTRYOPTIONS_PERU] = "ペルー";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "フィリピン";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "ピトケアン諸島";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "ポーランド";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "ポルトガル";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "プエルトリコ";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "カタール";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "レユニオン";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ルーマニア";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "ロシア";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "ルワンダ";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "サン・バルテルミー島";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "セントヘレナ";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "セントクリストファー・ネイビス";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "セントルシア";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "サン・マルタン島";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "サンピエール島・ミクロン島";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "セントビンセントおよびグレナディーン諸島";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "サモア";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "サンマリノ";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "サントメ・プリンシペ";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "サウジアラビア";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "セネガル";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "セルビア";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "セーシェル";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "シエラレオネ";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "シンガポール";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "スロバキア";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "スロベニア";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "ソロモン諸島";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "ソマリア";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "南アフリカ";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "サウスジョージア・サウスサンドウィッチ諸島 ";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "スペイン";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "スリランカ";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "スーダン";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "スリナム";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "スヴァールバル諸島およびヤンマイエン島";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "スワジランド";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "スウェーデン";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "スイス";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "シリア";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "台湾";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "タジキスタン";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "タンザニア";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "タイ";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "東ティモール";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "トーゴ";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "トケラウ";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "トンガ";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "トリニダード・トバゴ";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "チュニジア";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "トルコ";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "トルクメニスタン";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "タークス・カイコス諸島";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "ツバル";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "ウガンダ";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "ウクライナ";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "アラブ首長国連邦";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "イギリス";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "アメリカ";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "合衆国領有小離島 ";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "ウルグアイ";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "ウズベキスタン";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "バヌアツ";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "ベネズエラ";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "ベトナム";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "イギリス領バージン諸島";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "アメリカ領ヴァージン諸島";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "ウォリス・フツナ";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "西サハラ";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "イエメン";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ザンビア";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ジンバブエ";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "いいえ";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "不明";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "はい";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Vantive製品フィードバックポータルのリンク先のプライバシー通知を読み、理解しました。 ";
translations[PRODUCT_LOT] = "製品ロット";
translations[SHIPPING_DISTRIBUTION_LABEL] = "配送/配布ラベル";
translations[CARTON_LABEL] = "カートンラベル";
translations[INTERNAL_PRODUCT_LABEL] = "内部製品ラベル";
translations[TITLE_PD_RENAL] = "PD腎";
translations[TITLE_SOLUTIONS] = "ソリューション";
translations[TITLE_ACCESS] = "アクセス";
translations[TITLE_ALL_OTHER_PRODUCT] = "その他のすべての製品";
translations[REPORTED_PROBLEM] = "報告された問題";
translations[LOGIN] = "ログイン";
translations[SYSTEM_MENU] = "システムメニュー";
translations[INITIATE_PRODUCT_FEEDBACK] = "製品フィードバックを始める";
translations[FEEDBACK_STATUS] = "フィードバックのステータス";
translations[OKTACALLBACK] = "OktaCallback";
translations[VALID_EMAIL] = "有効なメールアドレスを入力してください";
translations[VALID_NUMERIC] = "製品コード";
translations[PLEASE_UPLOAD_IMAGE] = "画像をアップロードしてください";
translations[VALID_DATE] = "有効な日付を選択してください";
translations[QUANTITY] = "数量";
translations[EDIT] = "編集";
translations[DELETE] = "消去";
translations[LOT_SERIAL_NO] = "ロット・シリアルナンバー";
translations[LOT_NUMBER_NOT_FOUND] = "ロット番号が見つかりません";
translations[SEARCHING_LOT_NUMBER] = "ロット番号を検索中";
translations[PRODUCT_CODE_NOT_FOUND] = "製品コードが見つかりません";
translations[SEARCHING_PRODUCT_CODE] = "製品コードを検索中";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "ファイルタイプ(.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) は使用できません。";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "選択されたファイルのサイズが容量制限を超えています。ファイルを圧縮するか他のファイルを添付してください。";
translations[IMAGE_ICON] = "画像アイコンをクリックしてオプションを選択してください";
translations[LOGIN_TO_ACCOUNT] = "アカウントにログイン";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "アカウントにサインインする";
translations[PASSWORD] = "パスワード";
translations[SIGN_IN] = "ログイン";
translations[UNKNOWN] = "不明";
translations[ASKED_UNKNOWN] = "不明な質問";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "国を選択";
translations[CHINESE_SIMPLIFIED_CHINESE] = "中国語（簡体字）";
translations[DUTCH] = "オランダ語";
translations[ENGLISH] = "英語";
translations[FRENCH] = "フランス語";
translations[GERMAN] = "ドイツ語";
translations[ITALIAN] = "イタリア語";
translations[JAPANESE] = "日本語";
translations[KOREAN] = "韓国語";
translations[MANDARIN_TRADITIONAL_CHINESE] = "中国語（繁体字）";
translations[POLISH] = "ポーランド語";
translations[PORTUGUESE] = "ポルトガル語";
translations[SPANISH] = "スペイン語";
translations[THAI] = "タイ語";
translations[TURKISH] = "トルコ語";
translations[VIETNAMESE] = "ベトナム語";
translations[BROWSE] = "ブラウズ";
translations[FEEDBACK_SUBMITTED] = "フィードバックが送信されました";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "商品のフィードバックは正常に送信されました。 ご報告ありがとうございます。 参照番号を記載したメールが届きます。 医療製品の提供者として、当社の製品に対する顧客満足とフィードバックは、最高品質の製品を提供するという当社の目標に不可欠です。 お問い合わせください";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "質問や追加情報がある場合。";
translations[CLOSE] = "近い";
translations[PATIENT_AGE] = "患者年齡";
translations[ENTER_AGE] = "年齢を入力";
translations[PATIENT_DOB] = "患者誕生日";
translations[RELEVANT_ATTACHMENTS] = "関連する添付ファイルを入力してください";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "Vantiveアカウントの資格情報を入力してください";
translations[GET_PRODUCT_DETAILS] = "製品の詳細を取得";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "上の図 (図 2) を使用して、報告された問題の場所を特定します。";
translations[FACILITY_ADDRESS] = "施設住所";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "別の施設住所";
translations[CHOOSE_PRODUCT_CODE] = "入力されたロット/シリアル番号の製品コードを選択してください。";
translations[DECLINE] = "却下";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "ボネール、シント・ユースタティウス、サバ";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "キュラソー";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "南スーダン";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "エスワティーニ";
translations[FORM_HELP_TEXT] = "このフィールドでヘルプ テキストが利用可能であることを示します";
translations[YOUR_FIRST_NAME] = "あなたの名";
translations[YOUR_LAST_NAME] = "あなたの姓";
translations[MY_FIRST_NAME] = "私の名";
translations[MY_LAST_NAME] = "私の姓";
translations[PATIENT_FIRST_NAME] = "患者の名";
translations[PATIENT_LAST_NAME] = "患者の姓";
translations[REPORTER_FIRST_NAME] = "レポーターの名";
translations[REPORTER_LAST_NAME] = "レポーターの姓";
translations[EMPLOYEE_FIRST_NAME] = "従業員の名";
translations[EMPLOYEE_LAST_NAME] = "従業員の姓";
translations[END_USER_CUSTOMER_FIRST_NAME] = "エンド ユーザー/顧客の名";
translations[END_USER_CUSTOMER_LAST_NAME] = "エンド ユーザー/顧客の姓";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "連絡先の名";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "追加の連絡先の姓";
translations[COPYRIGHT] = "著作権 © ";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "すべての権利予約 | バージョン";
translations[ADD_ADDITIONAL_CONTACT] = "追加の連絡先";
translations[CONTACT_ME] = "お客様は連絡を希望していません。ご不明な点がございましたら、お問い合わせください。";
translations[DO_NOT_CONTACT] = "連絡しないでください";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "エンドユーザー/顧客施設名";
translations[END_USER_CUSTOMER_PHONE] = "エンドユーザー/顧客施設の電話番号";
translations[END_USER_CUSTOMER_EMAIL] = "エンド ユーザー/顧客の電子メール アドレス";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "エンドユーザー/顧客施設の住所";
translations[SAME_AS_PATIENT_ADDRESS] = "患者の住所と同じ";
translations[SAME_AS_REPORTER_ADDRESS] = "報告者の住所と同じ";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "エンドユーザー/顧客施設の住所と同じ";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "上の図 (図3) を使用して、報告された問題の場所を特定します。";
translations[CONTACT_US] = "お問い合わせ";
translations[LANDING_BRIEF_FOR_DEVICE] = "機器の修理、部品、サービス及び技術支援に関してはコールセンターへお問い合わせください";
translations[PATIENT_SEX] = "患者セックス";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "シスジェンダーの男性/少年";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "シスジェンダーの女性/女の子";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "トランスジェンダー男性/トランス男性/女性から男性へ";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "トランスジェンダー女性/トランス女性/男性から女性へ";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "その他の性別カテゴリー。ご指定ください";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "回答を拒否する";
translations[ATTENTION_NEEDED] = "!!!緊急の対応が必要です:製品フィードバックポータルの送信が失敗しました!";
translations[SUBMIT_ERR_MSG] = "再送信するには、「OK」をクリックしてから「送信」をクリックするか、(@@@) に苦情を電子メールで送信してください。";
translations[SUBMIT_RETRY_MSG] = "再送信した場合は、製品フィードバックポータルのメールボックスに確認メールが届いていることを確認してください。確認メールが届かない場合、送信は成功しませんでした。(@@@) に苦情をメールしてください。";
translations[OK] = "OK";

export default lang;